var map = {
	"./AboutPublishingCarousel": 1488,
	"./AboutPublishingCarousel.js": 1488,
	"./AboutPublishingCarousel/Main": 1489,
	"./AboutPublishingCarousel/Main.jsx": 1489,
	"./AboutPublishingCarousel/Quote": 357,
	"./AboutPublishingCarousel/Quote.jsx": 357,
	"./AddQualificationModal/AddQualificationModal": 211,
	"./AddQualificationModal/AddQualificationModal.jsx": 211,
	"./AddQualificationModal/Main": 920,
	"./AddQualificationModal/Main.jsx": 920,
	"./Admin/Channels/Index/ArticleOverviewTable": 1765,
	"./Admin/Channels/Index/ArticleOverviewTable.jsx": 1765,
	"./Admin/Channels/Index/Articles": 939,
	"./Admin/Channels/Index/Articles.jsx": 939,
	"./Admin/Channels/Index/ArticlesTable/BaseTable": 72,
	"./Admin/Channels/Index/ArticlesTable/BaseTable.jsx": 72,
	"./Admin/Channels/Index/ArticlesTable/ChannelRemoved": 943,
	"./Admin/Channels/Index/ArticlesTable/ChannelRemoved.jsx": 943,
	"./Admin/Channels/Index/ArticlesTable/ClaimExpired": 944,
	"./Admin/Channels/Index/ArticlesTable/ClaimExpired.jsx": 944,
	"./Admin/Channels/Index/ArticlesTable/EditorApproval": 942,
	"./Admin/Channels/Index/ArticlesTable/EditorApproval.jsx": 942,
	"./Admin/Channels/Index/ArticlesTable/EditorPreview": 940,
	"./Admin/Channels/Index/ArticlesTable/EditorPreview.jsx": 940,
	"./Admin/Channels/Index/ArticlesTable/InRereview": 1766,
	"./Admin/Channels/Index/ArticlesTable/InRereview.jsx": 1766,
	"./Admin/Channels/Index/ArticlesTable/InReview": 941,
	"./Admin/Channels/Index/ArticlesTable/InReview.jsx": 941,
	"./Admin/Channels/Index/ArticlesTableSection": 545,
	"./Admin/Channels/Index/ArticlesTableSection.jsx": 545,
	"./Admin/Channels/Index/ChannelAdminEditors": 945,
	"./Admin/Channels/Index/ChannelAdminEditors.jsx": 945,
	"./Admin/Channels/Index/ChannelCard": 946,
	"./Admin/Channels/Index/ChannelCard.jsx": 946,
	"./Admin/Channels/Index/ChannelEditorApprovalActivity": 948,
	"./Admin/Channels/Index/ChannelEditorApprovalActivity.jsx": 948,
	"./Admin/Channels/Index/ChannelEditorPreviewActivity": 949,
	"./Admin/Channels/Index/ChannelEditorPreviewActivity.jsx": 949,
	"./Admin/Channels/Index/ChannelsList": 950,
	"./Admin/Channels/Index/ChannelsList.jsx": 950,
	"./Admin/Channels/Index/CopyEmails": 947,
	"./Admin/Channels/Index/CopyEmails.jsx": 947,
	"./Admin/Channels/Index/EditorCheckActivity": 952,
	"./Admin/Channels/Index/EditorCheckActivity.jsx": 952,
	"./Admin/Channels/Index/EditorColumn": 546,
	"./Admin/Channels/Index/EditorColumn.jsx": 546,
	"./Admin/Channels/Index/InProgress": 953,
	"./Admin/Channels/Index/InProgress.jsx": 953,
	"./Admin/Channels/Index/InProgressOverview": 955,
	"./Admin/Channels/Index/InProgressOverview.jsx": 955,
	"./Admin/Channels/Index/Main": 1767,
	"./Admin/Channels/Index/Main.jsx": 1767,
	"./Admin/Channels/Index/MainMetrics": 954,
	"./Admin/Channels/Index/MainMetrics.jsx": 954,
	"./Admin/Channels/Index/Performance": 956,
	"./Admin/Channels/Index/Performance.jsx": 956,
	"./Admin/Channels/Index/SortButton": 951,
	"./Admin/Channels/Index/SortButton.jsx": 951,
	"./Admin/Channels/Index/shared": 153,
	"./Admin/Channels/Index/shared.js": 153,
	"./AdminAffiliations": 1768,
	"./AdminAffiliations.js": 1768,
	"./AdminAffiliations/CleanAffiliations": 957,
	"./AdminAffiliations/CleanAffiliations.jsx": 957,
	"./AdminAffiliations/EditModal": 547,
	"./AdminAffiliations/EditModal.jsx": 547,
	"./AdminAffiliations/Main": 1769,
	"./AdminAffiliations/Main.jsx": 1769,
	"./AdminArticleAvailableReviewers": 1770,
	"./AdminArticleAvailableReviewers.js": 1770,
	"./AdminArticleAvailableReviewers/Main": 1771,
	"./AdminArticleAvailableReviewers/Main.jsx": 1771,
	"./AdminArticleAvailableReviewers/Row": 959,
	"./AdminArticleAvailableReviewers/Row.jsx": 959,
	"./AdminArticleAvailableReviewers/Search": 960,
	"./AdminArticleAvailableReviewers/Search.jsx": 960,
	"./AdminArticleAvailableReviewers/Table": 958,
	"./AdminArticleAvailableReviewers/Table.jsx": 958,
	"./AdminArticleComments": 1772,
	"./AdminArticleComments.js": 1772,
	"./AdminArticleComments/FlagModal": 974,
	"./AdminArticleComments/FlagModal.jsx": 974,
	"./AdminArticleComments/FlagRow": 976,
	"./AdminArticleComments/FlagRow.jsx": 976,
	"./AdminArticleComments/Main": 1773,
	"./AdminArticleComments/Main.jsx": 1773,
	"./AdminArticleComments/Row": 975,
	"./AdminArticleComments/Row.jsx": 975,
	"./AdminArticleDesign/Main": 1774,
	"./AdminArticleDesign/Main.jsx": 1774,
	"./AdminArticleDesign/Promotion": 978,
	"./AdminArticleDesign/Promotion.jsx": 978,
	"./AdminArticleDesign/Sidebar": 977,
	"./AdminArticleDesign/Sidebar.jsx": 977,
	"./AdminArticleReviewers": 1775,
	"./AdminArticleReviewers.js": 1775,
	"./AdminArticleReviewers/ApprovalEditorRejectReviewModal": 979,
	"./AdminArticleReviewers/ApprovalEditorRejectReviewModal.jsx": 979,
	"./AdminArticleReviewers/HistoryModal": 980,
	"./AdminArticleReviewers/HistoryModal.jsx": 980,
	"./AdminArticleReviewers/Main": 1776,
	"./AdminArticleReviewers/Main.jsx": 1776,
	"./AdminArticleReviewers/RejectReviewModal": 983,
	"./AdminArticleReviewers/RejectReviewModal.jsx": 983,
	"./AdminArticleReviewers/RejectedModal": 984,
	"./AdminArticleReviewers/RejectedModal.jsx": 984,
	"./AdminArticleReviewers/Row": 981,
	"./AdminArticleReviewers/Row.jsx": 981,
	"./AdminArticleReviewers/ThoughtsModal": 982,
	"./AdminArticleReviewers/ThoughtsModal.jsx": 982,
	"./AdminAuthorStatsTable": 1777,
	"./AdminAuthorStatsTable.js": 1777,
	"./AdminAuthorStatsTable/ArticleStatsRow": 985,
	"./AdminAuthorStatsTable/ArticleStatsRow.jsx": 985,
	"./AdminAuthorStatsTable/BanModal": 986,
	"./AdminAuthorStatsTable/BanModal.jsx": 986,
	"./AdminAuthorStatsTable/FlagModal": 987,
	"./AdminAuthorStatsTable/FlagModal.jsx": 987,
	"./AdminAuthorStatsTable/Main": 1778,
	"./AdminAuthorStatsTable/Main.jsx": 1778,
	"./AdminAuthorStatsTable/Row": 988,
	"./AdminAuthorStatsTable/Row.jsx": 988,
	"./AdminBrowseSpecialtyDesign/Main": 1779,
	"./AdminBrowseSpecialtyDesign/Main.jsx": 1779,
	"./AdminBrowseSpecialtyDesign/Promotion": 548,
	"./AdminBrowseSpecialtyDesign/Promotion.jsx": 548,
	"./AdminBrowseSpecialtyDesign/Sidebar": 989,
	"./AdminBrowseSpecialtyDesign/Sidebar.jsx": 989,
	"./AdminCollectionApplications/ApproveModal": 312,
	"./AdminCollectionApplications/ApproveModal.jsx": 312,
	"./AdminCollectionApplications/Main": 1780,
	"./AdminCollectionApplications/Main.jsx": 1780,
	"./AdminCollectionApplications/NewTable": 990,
	"./AdminCollectionApplications/NewTable.jsx": 990,
	"./AdminCollectionApplications/RejectModal": 313,
	"./AdminCollectionApplications/RejectModal.jsx": 313,
	"./AdminCollectionApplications/RejectedApprovedTable": 991,
	"./AdminCollectionApplications/RejectedApprovedTable.jsx": 991,
	"./AdminCollectionApplications/Show": 1781,
	"./AdminCollectionApplications/Show.jsx": 1781,
	"./AdminCollections/CollectionArticles/Main": 1782,
	"./AdminCollections/CollectionArticles/Main.jsx": 1782,
	"./AdminCollections/CollectionTable": 992,
	"./AdminCollections/CollectionTable.jsx": 992,
	"./AdminCollections/CureusCurated": 994,
	"./AdminCollections/CureusCurated.jsx": 994,
	"./AdminCollections/GuestEditor": 995,
	"./AdminCollections/GuestEditor.jsx": 995,
	"./AdminCollections/GuestEditorActions/Main": 1783,
	"./AdminCollections/GuestEditorActions/Main.jsx": 1783,
	"./AdminCollections/GuestEditorActions/Table": 549,
	"./AdminCollections/GuestEditorActions/Table.jsx": 549,
	"./AdminCollections/GuestEditorDraftTable": 996,
	"./AdminCollections/GuestEditorDraftTable.jsx": 996,
	"./AdminCollections/GuestEditorTable": 997,
	"./AdminCollections/GuestEditorTable.jsx": 997,
	"./AdminCollections/Main": 1784,
	"./AdminCollections/Main.jsx": 1784,
	"./AdminDeferralReasons": 1785,
	"./AdminDeferralReasons.js": 1785,
	"./AdminDeferralReasons/DeleteModal": 998,
	"./AdminDeferralReasons/DeleteModal.jsx": 998,
	"./AdminDeferralReasons/EditModal": 999,
	"./AdminDeferralReasons/EditModal.jsx": 999,
	"./AdminDeferralReasons/Main": 1786,
	"./AdminDeferralReasons/Main.jsx": 1786,
	"./AdminDeferralReasons/NewModal": 1001,
	"./AdminDeferralReasons/NewModal.jsx": 1001,
	"./AdminDeferralReasons/Row": 1000,
	"./AdminDeferralReasons/Row.jsx": 1000,
	"./AdminDeskRejections/DeskRejectModal": 1002,
	"./AdminDeskRejections/DeskRejectModal.jsx": 1002,
	"./AdminDeskRejections/Main": 1787,
	"./AdminDeskRejections/Main.jsx": 1787,
	"./AdminDiscounts/Index": 1788,
	"./AdminDiscounts/Index.jsx": 1788,
	"./AdminEmailReminder/AdminEditorCheckboxes": 936,
	"./AdminEmailReminder/AdminEditorCheckboxes.jsx": 936,
	"./AdminEmailReminder/Checkbox": 544,
	"./AdminEmailReminder/Checkbox.jsx": 544,
	"./AdminEmailReminder/EditorPreviewApprovalReminderModal": 1414,
	"./AdminEmailReminder/EditorPreviewApprovalReminderModal.jsx": 1414,
	"./AdminEmailReminder/EmailReminderModal": 229,
	"./AdminEmailReminder/EmailReminderModal.jsx": 229,
	"./AdminEmailReminder/Main": 1789,
	"./AdminEmailReminder/Main.jsx": 1789,
	"./AdminHomepage/HeroTest": 922,
	"./AdminHomepage/HeroTest.jsx": 922,
	"./AdminHomepage/Main": 923,
	"./AdminHomepage/Main.jsx": 923,
	"./AdminHomepage/MainContent": 212,
	"./AdminHomepage/MainContent.jsx": 212,
	"./AdminHomepage/Sidebar": 219,
	"./AdminHomepage/Sidebar.jsx": 219,
	"./AdminInsideCureusArticles": 1790,
	"./AdminInsideCureusArticles.js": 1790,
	"./AdminInsideCureusArticles/Main": 1791,
	"./AdminInsideCureusArticles/Main.jsx": 1791,
	"./AdminInvoices": 1792,
	"./AdminInvoices.js": 1792,
	"./AdminInvoices/EditorialActivity": 1003,
	"./AdminInvoices/EditorialActivity.jsx": 1003,
	"./AdminInvoices/InvoiceTool": 1004,
	"./AdminInvoices/InvoiceTool.jsx": 1004,
	"./AdminInvoices/Main": 1793,
	"./AdminInvoices/Main.jsx": 1793,
	"./AdminInvoices/TotalEarningsTable": 1005,
	"./AdminInvoices/TotalEarningsTable.jsx": 1005,
	"./AdminInvoices/UpdateMiscItemModal": 1006,
	"./AdminInvoices/UpdateMiscItemModal.jsx": 1006,
	"./AdminMessageTable": 1794,
	"./AdminMessageTable.js": 1794,
	"./AdminMessageTable/ConfirmationModal": 1007,
	"./AdminMessageTable/ConfirmationModal.jsx": 1007,
	"./AdminMessageTable/EditMessageModal": 1008,
	"./AdminMessageTable/EditMessageModal.jsx": 1008,
	"./AdminMessageTable/Main": 1795,
	"./AdminMessageTable/Main.jsx": 1795,
	"./AdminMessageTable/MessageModal": 1796,
	"./AdminMessageTable/MessageModal.jsx": 1796,
	"./AdminMessageTable/Row": 1009,
	"./AdminMessageTable/Row.jsx": 1009,
	"./AdminResourceHistory": 1797,
	"./AdminResourceHistory.js": 1797,
	"./AdminResourceHistory/HistoryModal": 1010,
	"./AdminResourceHistory/HistoryModal.jsx": 1010,
	"./AdminResourceHistory/Main": 1798,
	"./AdminResourceHistory/Main.jsx": 1798,
	"./AdminUnwantedAccounts/BlackListTermCell": 1011,
	"./AdminUnwantedAccounts/BlackListTermCell.jsx": 1011,
	"./AdminUnwantedAccounts/EditTermModal": 1012,
	"./AdminUnwantedAccounts/EditTermModal.jsx": 1012,
	"./AdminUnwantedAccounts/Main": 1799,
	"./AdminUnwantedAccounts/Main.jsx": 1799,
	"./AdminUnwantedAccounts/NewTermModals": 314,
	"./AdminUnwantedAccounts/NewTermModals.jsx": 314,
	"./AdminUnwantedAccounts/Table": 1013,
	"./AdminUnwantedAccounts/Table.jsx": 1013,
	"./AdminUnwantedAccounts/UploadTermsModal": 1014,
	"./AdminUnwantedAccounts/UploadTermsModal.jsx": 1014,
	"./AdminUsers": 1800,
	"./AdminUsers.js": 1800,
	"./AdminUsers/Availability": 1801,
	"./AdminUsers/Availability.jsx": 1801,
	"./AdminUsers/FlaggedUsers": 1802,
	"./AdminUsers/FlaggedUsers.jsx": 1802,
	"./AdminUsers/Goals": 1803,
	"./AdminUsers/Goals.jsx": 1803,
	"./AdminUsers/GoogleCalendarEventAddModal": 1015,
	"./AdminUsers/GoogleCalendarEventAddModal.jsx": 1015,
	"./AdminUsers/Heatmap": 1804,
	"./AdminUsers/Heatmap.jsx": 1804,
	"./AdminUsers/Main": 1805,
	"./AdminUsers/Main.jsx": 1805,
	"./AdminUsers/MessageBoard": 1806,
	"./AdminUsers/MessageBoard.jsx": 1806,
	"./AdvisorTiles": 1807,
	"./AdvisorTiles.js": 1807,
	"./AdvisorTiles/Main": 1808,
	"./AdvisorTiles/Main.jsx": 1808,
	"./AdvisorTiles/Tile": 1016,
	"./AdvisorTiles/Tile.jsx": 1016,
	"./AllChannels/Card": 1017,
	"./AllChannels/Card.jsx": 1017,
	"./AllChannels/Index": 1809,
	"./AllChannels/Index.jsx": 1809,
	"./AllChannels/ToggleViewButton": 1018,
	"./AllChannels/ToggleViewButton.jsx": 1018,
	"./AnimalSubjects": 1810,
	"./AnimalSubjects.js": 1810,
	"./AnimalSubjects/Validator": 1811,
	"./AnimalSubjects/Validator.jsx": 1811,
	"./ApprovalEditorCompletions/Index": 1812,
	"./ApprovalEditorCompletions/Index.jsx": 1812,
	"./ApprovalEditorCompletions/ListTab": 1020,
	"./ApprovalEditorCompletions/ListTab.jsx": 1020,
	"./ApprovalEditorCompletions/MonthlyTab": 1021,
	"./ApprovalEditorCompletions/MonthlyTab.jsx": 1021,
	"./ApprovalEditorCompletions/ScoresDistribution": 1022,
	"./ApprovalEditorCompletions/ScoresDistribution.jsx": 1022,
	"./ApprovalEditorSuite/ActivityLog": 1023,
	"./ApprovalEditorSuite/ActivityLog.jsx": 1023,
	"./ApprovalEditorSuite/AddNoteModal": 1025,
	"./ApprovalEditorSuite/AddNoteModal.jsx": 1025,
	"./ApprovalEditorSuite/AeHistoryModal": 1024,
	"./ApprovalEditorSuite/AeHistoryModal.jsx": 1024,
	"./ApprovalEditorSuite/Concern": 1026,
	"./ApprovalEditorSuite/Concern.jsx": 1026,
	"./ApprovalEditorSuite/Main": 1813,
	"./ApprovalEditorSuite/Main.jsx": 1813,
	"./ApprovalEditorSuite/Other": 1031,
	"./ApprovalEditorSuite/Other.jsx": 1031,
	"./ApprovalEditorSuite/Performance/PerformanceSection": 1029,
	"./ApprovalEditorSuite/Performance/PerformanceSection.jsx": 1029,
	"./ApprovalEditorSuite/Performance/PerformanceTable": 1030,
	"./ApprovalEditorSuite/Performance/PerformanceTable.jsx": 1030,
	"./ApprovalEditorSuite/QueueInfo": 1028,
	"./ApprovalEditorSuite/QueueInfo.jsx": 1028,
	"./ApprovalEditorSuite/Snapshot": 1027,
	"./ApprovalEditorSuite/Snapshot.jsx": 1027,
	"./ApprovalEditorSuite/UtilityFunctions": 101,
	"./ApprovalEditorSuite/UtilityFunctions.js": 101,
	"./Article/ArticleModal": 993,
	"./Article/ArticleModal.jsx": 993,
	"./ArticleEditors": 1814,
	"./ArticleEditors.js": 1814,
	"./ArticleEditors/AffiliationsModal": 1032,
	"./ArticleEditors/AffiliationsModal.jsx": 1032,
	"./ArticleEditors/ChannelScreeningModal": 1033,
	"./ArticleEditors/ChannelScreeningModal.jsx": 1033,
	"./ArticleEditors/EditorDropdown": 155,
	"./ArticleEditors/EditorDropdown.jsx": 155,
	"./ArticleEditors/Main": 1815,
	"./ArticleEditors/Main.jsx": 1815,
	"./ArticleEditors/StateUpdateModal": 1034,
	"./ArticleEditors/StateUpdateModal.jsx": 1034,
	"./ArticleEditors/Table": 156,
	"./ArticleEditors/Table.jsx": 156,
	"./ArticleIndex": 1490,
	"./ArticleIndex.js": 1490,
	"./ArticleIndex/AdvancedSearch": 361,
	"./ArticleIndex/AdvancedSearch.jsx": 361,
	"./ArticleIndex/AdvancedSearchRow": 362,
	"./ArticleIndex/AdvancedSearchRow.jsx": 362,
	"./ArticleIndex/ArticleTypeModal": 363,
	"./ArticleIndex/ArticleTypeModal.jsx": 363,
	"./ArticleIndex/Categories": 364,
	"./ArticleIndex/Categories.jsx": 364,
	"./ArticleIndex/CategoriesModal": 365,
	"./ArticleIndex/CategoriesModal.jsx": 365,
	"./ArticleIndex/ChannelModal": 366,
	"./ArticleIndex/ChannelModal.jsx": 366,
	"./ArticleIndex/Channels": 367,
	"./ArticleIndex/Channels.jsx": 367,
	"./ArticleIndex/Filters": 368,
	"./ArticleIndex/Filters.jsx": 368,
	"./ArticleIndex/Header": 199,
	"./ArticleIndex/Header.jsx": 199,
	"./ArticleIndex/Main": 1491,
	"./ArticleIndex/Main.jsx": 1491,
	"./ArticleIndex/MostPopular": 1492,
	"./ArticleIndex/MostPopular.jsx": 1492,
	"./ArticleIndex/Search": 85,
	"./ArticleIndex/Search.jsx": 85,
	"./ArticleIndex/Sort": 369,
	"./ArticleIndex/Sort.jsx": 369,
	"./ArticleIndex/Types": 370,
	"./ArticleIndex/Types.jsx": 370,
	"./ArticleRating": 1816,
	"./ArticleRating.js": 1816,
	"./ArticleRating/EmailForm": 1035,
	"./ArticleRating/EmailForm.jsx": 1035,
	"./ArticleRating/Main": 1817,
	"./ArticleRating/Main.jsx": 1817,
	"./ArticleRating/Thanks": 1036,
	"./ArticleRating/Thanks.jsx": 1036,
	"./ArticleShow/AEPreview/Main": 1818,
	"./ArticleShow/AEPreview/Main.jsx": 1818,
	"./ArticleShow/ArticleTab": 1037,
	"./ArticleShow/ArticleTab.jsx": 1037,
	"./ArticleShow/AttachmentsTab": 1049,
	"./ArticleShow/AttachmentsTab.jsx": 1049,
	"./ArticleShow/AuthorsTab": 1039,
	"./ArticleShow/AuthorsTab.jsx": 1039,
	"./ArticleShow/FeatureBar": 1057,
	"./ArticleShow/FeatureBar.jsx": 1057,
	"./ArticleShow/FurtherReading": 1058,
	"./ArticleShow/FurtherReading.jsx": 1058,
	"./ArticleShow/HighlightPop": 1038,
	"./ArticleShow/HighlightPop.jsx": 1038,
	"./ArticleShow/LeftSidebar/Carat": 168,
	"./ArticleShow/LeftSidebar/Carat.jsx": 168,
	"./ArticleShow/LeftSidebar/Categories": 1055,
	"./ArticleShow/LeftSidebar/Categories.jsx": 1055,
	"./ArticleShow/LeftSidebar/Keywords": 1056,
	"./ArticleShow/LeftSidebar/Keywords.jsx": 1056,
	"./ArticleShow/LeftSidebar/Modals/SiqSignInModal": 1054,
	"./ArticleShow/LeftSidebar/Modals/SiqSignInModal.jsx": 1054,
	"./ArticleShow/LeftSidebar/Sidebar": 319,
	"./ArticleShow/LeftSidebar/Sidebar.jsx": 319,
	"./ArticleShow/LeftSidebar/Siq": 320,
	"./ArticleShow/LeftSidebar/Siq.jsx": 320,
	"./ArticleShow/LeftSidebar/TOCLink": 1051,
	"./ArticleShow/LeftSidebar/TOCLink.jsx": 1051,
	"./ArticleShow/LeftSidebar/TableOfContents": 1050,
	"./ArticleShow/LeftSidebar/TableOfContents.jsx": 1050,
	"./ArticleShow/Main": 1819,
	"./ArticleShow/Main.jsx": 1819,
	"./ArticleShow/Metrics/ArticleReads": 1041,
	"./ArticleShow/Metrics/ArticleReads.jsx": 1041,
	"./ArticleShow/Metrics/BarChart": 1044,
	"./ArticleShow/Metrics/BarChart.jsx": 1044,
	"./ArticleShow/Metrics/Citations": 1047,
	"./ArticleShow/Metrics/Citations.jsx": 1047,
	"./ArticleShow/Metrics/IntervalButton": 250,
	"./ArticleShow/Metrics/IntervalButton.jsx": 250,
	"./ArticleShow/Metrics/LineChart": 1043,
	"./ArticleShow/Metrics/LineChart.jsx": 1043,
	"./ArticleShow/Metrics/MapButton": 178,
	"./ArticleShow/Metrics/MapButton.jsx": 178,
	"./ArticleShow/Metrics/MapTable": 317,
	"./ArticleShow/Metrics/MapTable.jsx": 317,
	"./ArticleShow/Metrics/MetricsTab": 1040,
	"./ArticleShow/Metrics/MetricsTab.jsx": 1040,
	"./ArticleShow/Metrics/Plummary": 1048,
	"./ArticleShow/Metrics/Plummary.jsx": 1048,
	"./ArticleShow/Metrics/ReadsCard": 249,
	"./ArticleShow/Metrics/ReadsCard.jsx": 249,
	"./ArticleShow/Metrics/ReadsChart": 1042,
	"./ArticleShow/Metrics/ReadsChart.jsx": 1042,
	"./ArticleShow/Metrics/UsMap": 1046,
	"./ArticleShow/Metrics/UsMap.jsx": 1046,
	"./ArticleShow/Metrics/WorldMap": 1045,
	"./ArticleShow/Metrics/WorldMap.jsx": 1045,
	"./ArticleShow/Modal/CitationModal": 321,
	"./ArticleShow/Modal/CitationModal.jsx": 321,
	"./ArticleShow/MoreAbout/MoreAbout": 1063,
	"./ArticleShow/MoreAbout/MoreAbout.jsx": 1063,
	"./ArticleShow/MoreAbout/Tile": 1064,
	"./ArticleShow/MoreAbout/Tile.jsx": 1064,
	"./ArticleShow/NavBarItem": 251,
	"./ArticleShow/NavBarItem.jsx": 251,
	"./ArticleShow/NavItems": 316,
	"./ArticleShow/NavItems.jsx": 316,
	"./ArticleShow/RightSidebar": 1059,
	"./ArticleShow/RightSidebar.jsx": 1059,
	"./ArticleShow/ShareBar": 1065,
	"./ArticleShow/ShareBar.jsx": 1065,
	"./ArticleShow/Sidebar/ChannelBadge": 1820,
	"./ArticleShow/Sidebar/ChannelBadge.jsx": 1820,
	"./ArticleShow/Sidebar/MostPopularArticles/Articles": 524,
	"./ArticleShow/Sidebar/MostPopularArticles/Articles.jsx": 524,
	"./ArticleShow/Sidebar/MostPopularArticles/Card": 157,
	"./ArticleShow/Sidebar/MostPopularArticles/Card.jsx": 157,
	"./ArticleShow/Sidebar/Promotion": 1060,
	"./ArticleShow/Sidebar/Promotion.jsx": 1060,
	"./ArticleShow/TopSection": 318,
	"./ArticleShow/TopSection.jsx": 318,
	"./AttachmentMixin": 125,
	"./AttachmentMixin.js": 125,
	"./AuthorContributions/Authorship": 1066,
	"./AuthorContributions/Authorship.jsx": 1066,
	"./AuthorContributions/Index": 1821,
	"./AuthorContributions/Index.jsx": 1821,
	"./AuthorContributions/Selector": 1067,
	"./AuthorContributions/Selector.jsx": 1067,
	"./AuthorsHub/GoalModal": 1068,
	"./AuthorsHub/GoalModal.jsx": 1068,
	"./AuthorsHub/GoalOption": 1069,
	"./AuthorsHub/GoalOption.jsx": 1069,
	"./AuthorsHub/GoalSelector": 551,
	"./AuthorsHub/GoalSelector.jsx": 551,
	"./AuthorsHub/Main": 1822,
	"./AuthorsHub/Main.jsx": 1822,
	"./AuthorsHub/SignInModal": 1070,
	"./AuthorsHub/SignInModal.jsx": 1070,
	"./AuthorsHub/Tab": 1072,
	"./AuthorsHub/Tab.jsx": 1072,
	"./AuthorsHub/TabCard": 1073,
	"./AuthorsHub/TabCard.jsx": 1073,
	"./AuthorsHub/TabsSection": 1071,
	"./AuthorsHub/TabsSection.jsx": 1071,
	"./AuthorsHub/UserTestimonial/Testimonial": 1074,
	"./AuthorsHub/UserTestimonial/Testimonial.jsx": 1074,
	"./AuthorsHub/UserTestimonial/UserTestimonial": 1823,
	"./AuthorsHub/UserTestimonial/UserTestimonial.jsx": 1823,
	"./AvatarUploader": 1824,
	"./AvatarUploader.js": 1824,
	"./AvatarUploaderForm/Main": 1493,
	"./AvatarUploaderForm/Main.jsx": 1493,
	"./BannerUploader/Consent": 1075,
	"./BannerUploader/Consent.jsx": 1075,
	"./BannerUploader/EditFile": 1076,
	"./BannerUploader/EditFile.jsx": 1076,
	"./BannerUploader/License": 1077,
	"./BannerUploader/License.jsx": 1077,
	"./BannerUploader/LicenseFile": 1078,
	"./BannerUploader/LicenseFile.jsx": 1078,
	"./BannerUploader/LicenseLink": 1080,
	"./BannerUploader/LicenseLink.jsx": 1080,
	"./BannerUploader/Main": 1825,
	"./BannerUploader/Main.jsx": 1825,
	"./BannerUploader/NewFile": 1081,
	"./BannerUploader/NewFile.jsx": 1081,
	"./BannerUploader/UploadLicenseModal": 1079,
	"./BannerUploader/UploadLicenseModal.jsx": 1079,
	"./Boost": 1826,
	"./Boost.js": 1826,
	"./Boost/BoostModal": 325,
	"./Boost/BoostModal.jsx": 325,
	"./Boost/Card": 90,
	"./Boost/Card.jsx": 90,
	"./Boost/Info": 1494,
	"./Boost/Info.jsx": 1494,
	"./Boost/Main": 1827,
	"./Boost/Main.jsx": 1827,
	"./Boost/Selection": 1083,
	"./Boost/Selection.jsx": 1083,
	"./BrowseIndex/BrowseArticles/ArticleContent": 1090,
	"./BrowseIndex/BrowseArticles/ArticleContent.jsx": 1090,
	"./BrowseIndex/BrowseArticles/BrowseArticles": 1091,
	"./BrowseIndex/BrowseArticles/BrowseArticles.jsx": 1091,
	"./BrowseIndex/BrowseContents/BrowseContents": 1092,
	"./BrowseIndex/BrowseContents/BrowseContents.jsx": 1092,
	"./BrowseIndex/BrowseContents/Content": 1094,
	"./BrowseIndex/BrowseContents/Content.jsx": 1094,
	"./BrowseIndex/BrowseContents/Filters": 1093,
	"./BrowseIndex/BrowseContents/Filters.jsx": 1093,
	"./BrowseIndex/Index": 1828,
	"./BrowseIndex/Index.jsx": 1828,
	"./BrowseIndex/MostPopular": 1829,
	"./BrowseIndex/MostPopular.jsx": 1829,
	"./BrowseIndex/Sidebars/Buttons": 1096,
	"./BrowseIndex/Sidebars/Buttons.jsx": 1096,
	"./BrowseIndex/Sidebars/Categories": 1095,
	"./BrowseIndex/Sidebars/Categories.jsx": 1095,
	"./BrowseIndex/Sidebars/CategorySidebar": 326,
	"./BrowseIndex/Sidebars/CategorySidebar.jsx": 326,
	"./BrowseIndex/Sidebars/RightSideBar": 1097,
	"./BrowseIndex/Sidebars/RightSideBar.jsx": 1097,
	"./CampaignArticles": 1830,
	"./CampaignArticles.js": 1830,
	"./CampaignArticles/AddArticleInput": 553,
	"./CampaignArticles/AddArticleInput.jsx": 553,
	"./CampaignArticles/ArticleListItem": 1098,
	"./CampaignArticles/ArticleListItem.jsx": 1098,
	"./CampaignArticles/CategoryModal": 1099,
	"./CampaignArticles/CategoryModal.jsx": 1099,
	"./CampaignArticles/CategorySelector": 1831,
	"./CampaignArticles/CategorySelector.jsx": 1831,
	"./CampaignArticles/CureusUArticleListItem": 554,
	"./CampaignArticles/CureusUArticleListItem.jsx": 554,
	"./CampaignArticles/CureusUSelector": 1832,
	"./CampaignArticles/CureusUSelector.jsx": 1832,
	"./CampaignArticles/EmailListModal": 1100,
	"./CampaignArticles/EmailListModal.jsx": 1100,
	"./CampaignArticles/EmailListSelector": 1833,
	"./CampaignArticles/EmailListSelector.jsx": 1833,
	"./CampaignArticles/Main": 1834,
	"./CampaignArticles/Main.jsx": 1834,
	"./CampaignArticles/UpdateKlaviyoTemplateButton": 1101,
	"./CampaignArticles/UpdateKlaviyoTemplateButton.jsx": 1101,
	"./CampaignPerformance/DetailedPerformance": 1102,
	"./CampaignPerformance/DetailedPerformance.jsx": 1102,
	"./CampaignPerformance/Main": 1835,
	"./CampaignPerformance/Main.jsx": 1835,
	"./CampaignPerformance/Summary": 1103,
	"./CampaignPerformance/Summary.jsx": 1103,
	"./CampaignSections": 1836,
	"./CampaignSections.js": 1836,
	"./CampaignSections/Main": 1104,
	"./CampaignSections/Main.jsx": 1104,
	"./CampaignSections/SectionListItem": 1105,
	"./CampaignSections/SectionListItem.jsx": 1105,
	"./Campaigns/Main": 1837,
	"./Campaigns/Main.jsx": 1837,
	"./Campaigns/OpenClickChart": 1106,
	"./Campaigns/OpenClickChart.jsx": 1106,
	"./Campaigns/Stats": 1107,
	"./Campaigns/Stats.jsx": 1107,
	"./Campaigns/StatsTable": 555,
	"./Campaigns/StatsTable.jsx": 555,
	"./Categories/Index": 1838,
	"./Categories/Index.jsx": 1838,
	"./ChangeDetectorAlert": 571,
	"./ChangeDetectorAlert.js": 571,
	"./ChannelCampaigns/ChannelCampaignModal": 126,
	"./ChannelCampaigns/ChannelCampaignModal.jsx": 126,
	"./ChannelCampaigns/ChannelOfficialRejectionModal": 1108,
	"./ChannelCampaigns/ChannelOfficialRejectionModal.jsx": 1108,
	"./ChannelCampaigns/ConfirmationModal": 1109,
	"./ChannelCampaigns/ConfirmationModal.jsx": 1109,
	"./ChannelCampaigns/EmailRequestsMain": 1110,
	"./ChannelCampaigns/EmailRequestsMain.jsx": 1110,
	"./ChannelCampaigns/Index": 1839,
	"./ChannelCampaigns/Index.jsx": 1839,
	"./ChannelCampaigns/MemberRequestsMain": 1111,
	"./ChannelCampaigns/MemberRequestsMain.jsx": 1111,
	"./ChannelCampaigns/RequestsIndex": 1840,
	"./ChannelCampaigns/RequestsIndex.jsx": 1840,
	"./ChannelCarousel/Channel": 376,
	"./ChannelCarousel/Channel.jsx": 376,
	"./ChannelCarousel/Main": 1495,
	"./ChannelCarousel/Main.jsx": 1495,
	"./ChannelDesign/About/About": 1112,
	"./ChannelDesign/About/About.jsx": 1112,
	"./ChannelDesign/About/AboutContactModal": 120,
	"./ChannelDesign/About/AboutContactModal.jsx": 120,
	"./ChannelDesign/About/AboutMainSettings": 1113,
	"./ChannelDesign/About/AboutMainSettings.jsx": 1113,
	"./ChannelDesign/About/AboutModal": 119,
	"./ChannelDesign/About/AboutModal.jsx": 119,
	"./ChannelDesign/About/AboutSidebarContent": 1116,
	"./ChannelDesign/About/AboutSidebarContent.jsx": 1116,
	"./ChannelDesign/About/AboutSidebarSettings": 1114,
	"./ChannelDesign/About/AboutSidebarSettings.jsx": 1114,
	"./ChannelDesign/About/AboutWidget": 1115,
	"./ChannelDesign/About/AboutWidget.jsx": 1115,
	"./ChannelDesign/About/ContactModal": 1841,
	"./ChannelDesign/About/ContactModal.jsx": 1841,
	"./ChannelDesign/About/SidebarWidgets/AboutContact": 1117,
	"./ChannelDesign/About/SidebarWidgets/AboutContact.jsx": 1117,
	"./ChannelDesign/About/SidebarWidgets/SocialAccountIcon": 179,
	"./ChannelDesign/About/SidebarWidgets/SocialAccountIcon.jsx": 179,
	"./ChannelDesign/About/SidebarWidgets/SocialAccountsWidget": 1118,
	"./ChannelDesign/About/SidebarWidgets/SocialAccountsWidget.jsx": 1118,
	"./ChannelDesign/About/SocialAccountsModal": 121,
	"./ChannelDesign/About/SocialAccountsModal.jsx": 121,
	"./ChannelDesign/About/SocialModalInput": 59,
	"./ChannelDesign/About/SocialModalInput.jsx": 59,
	"./ChannelDesign/Abstracts": 1119,
	"./ChannelDesign/Abstracts.jsx": 1119,
	"./ChannelDesign/AdminMain": 1842,
	"./ChannelDesign/AdminMain.jsx": 1842,
	"./ChannelDesign/Articles": 1121,
	"./ChannelDesign/Articles.jsx": 1121,
	"./ChannelDesign/DeleteButton": 18,
	"./ChannelDesign/DeleteButton.jsx": 18,
	"./ChannelDesign/Hero": 1125,
	"./ChannelDesign/Hero.jsx": 1125,
	"./ChannelDesign/Home": 273,
	"./ChannelDesign/Home.jsx": 273,
	"./ChannelDesign/HomepageSettings": 221,
	"./ChannelDesign/HomepageSettings.jsx": 221,
	"./ChannelDesign/Internal": 1123,
	"./ChannelDesign/Internal.jsx": 1123,
	"./ChannelDesign/MainContent": 292,
	"./ChannelDesign/MainContent.jsx": 292,
	"./ChannelDesign/MainWidgets/Cards/Abstract50Card": 297,
	"./ChannelDesign/MainWidgets/Cards/Abstract50Card.jsx": 297,
	"./ChannelDesign/MainWidgets/Cards/Article100Card": 1843,
	"./ChannelDesign/MainWidgets/Cards/Article100Card.jsx": 1843,
	"./ChannelDesign/MainWidgets/Cards/Article50Card": 296,
	"./ChannelDesign/MainWidgets/Cards/Article50Card.jsx": 296,
	"./ChannelDesign/MainWidgets/Cards/Channel100Card": 94,
	"./ChannelDesign/MainWidgets/Cards/Channel100Card.jsx": 94,
	"./ChannelDesign/MainWidgets/Cards/Poster50Card": 298,
	"./ChannelDesign/MainWidgets/Cards/Poster50Card.jsx": 298,
	"./ChannelDesign/MainWidgets/ChannelTeam/TeamMemberCard": 98,
	"./ChannelDesign/MainWidgets/ChannelTeam/TeamMemberCard.jsx": 98,
	"./ChannelDesign/MainWidgets/ChannelTeam/TeamMemberRow": 209,
	"./ChannelDesign/MainWidgets/ChannelTeam/TeamMemberRow.jsx": 209,
	"./ChannelDesign/MainWidgets/ChannelTeamWidget": 299,
	"./ChannelDesign/MainWidgets/ChannelTeamWidget.jsx": 299,
	"./ChannelDesign/MainWidgets/CustomContentWidget": 295,
	"./ChannelDesign/MainWidgets/CustomContentWidget.jsx": 295,
	"./ChannelDesign/MainWidgets/FeaturedMultimediaWidget": 257,
	"./ChannelDesign/MainWidgets/FeaturedMultimediaWidget.jsx": 257,
	"./ChannelDesign/MainWidgets/InternalContentWidget": 294,
	"./ChannelDesign/MainWidgets/InternalContentWidget.jsx": 294,
	"./ChannelDesign/MainWidgets/RecentlyPublishedWidget": 293,
	"./ChannelDesign/MainWidgets/RecentlyPublishedWidget.jsx": 293,
	"./ChannelDesign/Meetings": 1124,
	"./ChannelDesign/Meetings.jsx": 1124,
	"./ChannelDesign/MobileNavBar": 1844,
	"./ChannelDesign/MobileNavBar.jsx": 1844,
	"./ChannelDesign/Modals/ChannelTeam": 111,
	"./ChannelDesign/Modals/ChannelTeam.jsx": 111,
	"./ChannelDesign/Modals/ChannelTeamMember": 235,
	"./ChannelDesign/Modals/ChannelTeamMember.jsx": 235,
	"./ChannelDesign/Modals/ChannelTeamSidebar": 112,
	"./ChannelDesign/Modals/ChannelTeamSidebar.jsx": 112,
	"./ChannelDesign/Modals/CureusPromotionModal": 114,
	"./ChannelDesign/Modals/CureusPromotionModal.jsx": 114,
	"./ChannelDesign/Modals/CustomContentModal": 110,
	"./ChannelDesign/Modals/CustomContentModal.jsx": 110,
	"./ChannelDesign/Modals/FeaturedMultimediaModal": 256,
	"./ChannelDesign/Modals/FeaturedMultimediaModal.jsx": 256,
	"./ChannelDesign/Modals/HeroEditModal": 1126,
	"./ChannelDesign/Modals/HeroEditModal.jsx": 1126,
	"./ChannelDesign/Modals/InputElements/CustomContentModalInputButtons": 102,
	"./ChannelDesign/Modals/InputElements/CustomContentModalInputButtons.jsx": 102,
	"./ChannelDesign/Modals/InputElements/PollOption": 236,
	"./ChannelDesign/Modals/InputElements/PollOption.jsx": 236,
	"./ChannelDesign/Modals/InputElements/RadioInput": 233,
	"./ChannelDesign/Modals/InputElements/RadioInput.jsx": 233,
	"./ChannelDesign/Modals/InputElements/SizeInput": 154,
	"./ChannelDesign/Modals/InputElements/SizeInput.jsx": 154,
	"./ChannelDesign/Modals/InputElements/TextField": 234,
	"./ChannelDesign/Modals/InputElements/TextField.jsx": 234,
	"./ChannelDesign/Modals/InternalContent": 79,
	"./ChannelDesign/Modals/InternalContent.jsx": 79,
	"./ChannelDesign/Modals/MostPopularContentModal": 118,
	"./ChannelDesign/Modals/MostPopularContentModal.jsx": 118,
	"./ChannelDesign/Modals/OverviewSidebarModal": 115,
	"./ChannelDesign/Modals/OverviewSidebarModal.jsx": 115,
	"./ChannelDesign/Modals/Poll": 117,
	"./ChannelDesign/Modals/Poll.jsx": 117,
	"./ChannelDesign/Modals/Promotion": 113,
	"./ChannelDesign/Modals/Promotion.jsx": 113,
	"./ChannelDesign/Modals/RecentlyPublished": 290,
	"./ChannelDesign/Modals/RecentlyPublished.jsx": 290,
	"./ChannelDesign/Modals/TwitterSidebarModal": 116,
	"./ChannelDesign/Modals/TwitterSidebarModal.jsx": 116,
	"./ChannelDesign/NavItems": 1120,
	"./ChannelDesign/NavItems.jsx": 1120,
	"./ChannelDesign/NoArticlesDisplay": 300,
	"./ChannelDesign/NoArticlesDisplay.jsx": 300,
	"./ChannelDesign/Posters": 1122,
	"./ChannelDesign/Posters.jsx": 1122,
	"./ChannelDesign/SettingsButton": 32,
	"./ChannelDesign/SettingsButton.jsx": 32,
	"./ChannelDesign/SidebarContent": 301,
	"./ChannelDesign/SidebarContent.jsx": 301,
	"./ChannelDesign/SidebarSettings": 291,
	"./ChannelDesign/SidebarSettings.jsx": 291,
	"./ChannelDesign/SidebarWidgets/CureusPromotion": 304,
	"./ChannelDesign/SidebarWidgets/CureusPromotion.jsx": 304,
	"./ChannelDesign/SidebarWidgets/MostPopularContent": 308,
	"./ChannelDesign/SidebarWidgets/MostPopularContent.jsx": 308,
	"./ChannelDesign/SidebarWidgets/Overview/OverviewInfoRow": 136,
	"./ChannelDesign/SidebarWidgets/Overview/OverviewInfoRow.jsx": 136,
	"./ChannelDesign/SidebarWidgets/Overview/OverviewModalInput": 103,
	"./ChannelDesign/SidebarWidgets/Overview/OverviewModalInput.jsx": 103,
	"./ChannelDesign/SidebarWidgets/OverviewWidget": 305,
	"./ChannelDesign/SidebarWidgets/OverviewWidget.jsx": 305,
	"./ChannelDesign/SidebarWidgets/Poll/PollOption": 307,
	"./ChannelDesign/SidebarWidgets/Poll/PollOption.jsx": 307,
	"./ChannelDesign/SidebarWidgets/Poll/PollWidget": 306,
	"./ChannelDesign/SidebarWidgets/Poll/PollWidget.jsx": 306,
	"./ChannelDesign/SidebarWidgets/PromotionWidget": 303,
	"./ChannelDesign/SidebarWidgets/PromotionWidget.jsx": 303,
	"./ChannelDesign/SidebarWidgets/TeamMemberSidebar": 302,
	"./ChannelDesign/SidebarWidgets/TeamMemberSidebar.jsx": 302,
	"./ChannelDesign/SidebarWidgets/TwitterWidget": 913,
	"./ChannelDesign/SidebarWidgets/TwitterWidget.jsx": 913,
	"./ChannelDesign/UpdateButton": 23,
	"./ChannelDesign/UpdateButton.jsx": 23,
	"./ChannelDesignWidget": 1845,
	"./ChannelDesignWidget.js": 1845,
	"./ChannelDesignWidget/ChannelTeamMember": 1127,
	"./ChannelDesignWidget/ChannelTeamMember.jsx": 1127,
	"./ChannelDesignWidget/Main": 1846,
	"./ChannelDesignWidget/Main.jsx": 1846,
	"./ChannelDesignWidget/NewSidebarWidget": 1130,
	"./ChannelDesignWidget/NewSidebarWidget.jsx": 1130,
	"./ChannelDesignWidget/Promotion": 556,
	"./ChannelDesignWidget/Promotion.jsx": 556,
	"./ChannelDesignWidget/Twitter": 1129,
	"./ChannelDesignWidget/Twitter.jsx": 1129,
	"./ChannelDesignWidget/Widget": 1128,
	"./ChannelDesignWidget/Widget.jsx": 1128,
	"./Channels/AbstractStates/Abandoned": 1131,
	"./Channels/AbstractStates/Abandoned.jsx": 1131,
	"./Channels/AbstractStates/All": 1132,
	"./Channels/AbstractStates/All.jsx": 1132,
	"./Channels/AbstractStates/ChannelEditorApproval": 1133,
	"./Channels/AbstractStates/ChannelEditorApproval.jsx": 1133,
	"./Channels/AbstractStates/ChannelEditorApprovalDeferred": 1134,
	"./Channels/AbstractStates/ChannelEditorApprovalDeferred.jsx": 1134,
	"./Channels/AbstractStates/DeskRejected": 1135,
	"./Channels/AbstractStates/DeskRejected.jsx": 1135,
	"./Channels/AbstractStates/Draft": 1136,
	"./Channels/AbstractStates/Draft.jsx": 1136,
	"./Channels/AbstractStates/Published": 1137,
	"./Channels/AbstractStates/Published.jsx": 1137,
	"./Channels/Abstracts": 1138,
	"./Channels/Abstracts.jsx": 1138,
	"./Channels/AddPersonModal": 962,
	"./Channels/AddPersonModal.jsx": 962,
	"./Channels/ArticleStates/Abandoned": 1139,
	"./Channels/ArticleStates/Abandoned.jsx": 1139,
	"./Channels/ArticleStates/All": 1140,
	"./Channels/ArticleStates/All.jsx": 1140,
	"./Channels/ArticleStates/Approved": 1141,
	"./Channels/ArticleStates/Approved.jsx": 1141,
	"./Channels/ArticleStates/Blocked": 1142,
	"./Channels/ArticleStates/Blocked.jsx": 1142,
	"./Channels/ArticleStates/ChannelEditorApproval": 1143,
	"./Channels/ArticleStates/ChannelEditorApproval.jsx": 1143,
	"./Channels/ArticleStates/ChannelEditorApprovalDeferred": 1144,
	"./Channels/ArticleStates/ChannelEditorApprovalDeferred.jsx": 1144,
	"./Channels/ArticleStates/ChannelEditorApprovalMyWork": 1145,
	"./Channels/ArticleStates/ChannelEditorApprovalMyWork.jsx": 1145,
	"./Channels/ArticleStates/CureusEditorApproval": 1146,
	"./Channels/ArticleStates/CureusEditorApproval.jsx": 1146,
	"./Channels/ArticleStates/CureusEditorApprovalDeferred": 1147,
	"./Channels/ArticleStates/CureusEditorApprovalDeferred.jsx": 1147,
	"./Channels/ArticleStates/DeskRejected": 1148,
	"./Channels/ArticleStates/DeskRejected.jsx": 1148,
	"./Channels/ArticleStates/Draft": 1149,
	"./Channels/ArticleStates/Draft.jsx": 1149,
	"./Channels/ArticleStates/EditorCheck": 1150,
	"./Channels/ArticleStates/EditorCheck.jsx": 1150,
	"./Channels/ArticleStates/EditorCheckDeferred": 1151,
	"./Channels/ArticleStates/EditorCheckDeferred.jsx": 1151,
	"./Channels/ArticleStates/EditorPreview": 1152,
	"./Channels/ArticleStates/EditorPreview.jsx": 1152,
	"./Channels/ArticleStates/EditorPreviewDeferred": 1153,
	"./Channels/ArticleStates/EditorPreviewDeferred.jsx": 1153,
	"./Channels/ArticleStates/EditorPreviewMyWork": 1154,
	"./Channels/ArticleStates/EditorPreviewMyWork.jsx": 1154,
	"./Channels/ArticleStates/EditorScreening": 1155,
	"./Channels/ArticleStates/EditorScreening.jsx": 1155,
	"./Channels/ArticleStates/EditorScreeningMyWork": 1156,
	"./Channels/ArticleStates/EditorScreeningMyWork.jsx": 1156,
	"./Channels/ArticleStates/InRereview": 1157,
	"./Channels/ArticleStates/InRereview.jsx": 1157,
	"./Channels/ArticleStates/InReview": 1158,
	"./Channels/ArticleStates/InReview.jsx": 1158,
	"./Channels/ArticleStates/Published": 1159,
	"./Channels/ArticleStates/Published.jsx": 1159,
	"./Channels/ArticleStates/RejectedChannelScreening": 1160,
	"./Channels/ArticleStates/RejectedChannelScreening.jsx": 1160,
	"./Channels/ArticleStates/ReviewsComplete": 1161,
	"./Channels/ArticleStates/ReviewsComplete.jsx": 1161,
	"./Channels/Articles": 1162,
	"./Channels/Articles.jsx": 1162,
	"./Channels/Dashboard": 1163,
	"./Channels/Dashboard.jsx": 1163,
	"./Channels/Main": 1847,
	"./Channels/Main.jsx": 1847,
	"./Channels/MyWorksMain": 1848,
	"./Channels/MyWorksMain.jsx": 1848,
	"./Channels/PeerReviewers": 309,
	"./Channels/PeerReviewers.jsx": 309,
	"./Channels/PeerReviewersMain": 1849,
	"./Channels/PeerReviewersMain.jsx": 1849,
	"./Channels/PosterStates/Abandoned": 1175,
	"./Channels/PosterStates/Abandoned.jsx": 1175,
	"./Channels/PosterStates/All": 1176,
	"./Channels/PosterStates/All.jsx": 1176,
	"./Channels/PosterStates/ChannelEditorApproval": 1172,
	"./Channels/PosterStates/ChannelEditorApproval.jsx": 1172,
	"./Channels/PosterStates/ChannelEditorApprovalDeferred": 1171,
	"./Channels/PosterStates/ChannelEditorApprovalDeferred.jsx": 1171,
	"./Channels/PosterStates/DeskRejected": 1174,
	"./Channels/PosterStates/DeskRejected.jsx": 1174,
	"./Channels/PosterStates/Draft": 1170,
	"./Channels/PosterStates/Draft.jsx": 1170,
	"./Channels/PosterStates/Published": 1173,
	"./Channels/PosterStates/Published.jsx": 1173,
	"./Channels/Posters": 1169,
	"./Channels/Posters.jsx": 1169,
	"./Channels/ReviewerTableMain": 1177,
	"./Channels/ReviewerTableMain.jsx": 1177,
	"./Channels/ReviewerTableStates/Invited": 1178,
	"./Channels/ReviewerTableStates/Invited.jsx": 1178,
	"./Channels/ReviewerTableStates/Reviewing": 1179,
	"./Channels/ReviewerTableStates/Reviewing.jsx": 1179,
	"./Channels/UploadPeerReviewers": 961,
	"./Channels/UploadPeerReviewers.jsx": 961,
	"./CkEditor/LatexInfoModal": 1180,
	"./CkEditor/LatexInfoModal.jsx": 1180,
	"./CkEditor/ModalTrigger": 1850,
	"./CkEditor/ModalTrigger.jsx": 1850,
	"./CollectionArticles/CollectionArticleCard": 329,
	"./CollectionArticles/CollectionArticleCard.jsx": 329,
	"./CollectionArticles/KeywordSearchedArticles": 1181,
	"./CollectionArticles/KeywordSearchedArticles.jsx": 1181,
	"./CollectionArticles/Main": 1851,
	"./CollectionArticles/Main.jsx": 1851,
	"./CollectionFaqs/FaqItem": 1182,
	"./CollectionFaqs/FaqItem.jsx": 1182,
	"./CollectionFaqs/Index": 1852,
	"./CollectionFaqs/Index.jsx": 1852,
	"./CollectionFaqs/NewFaq": 1183,
	"./CollectionFaqs/NewFaq.jsx": 1183,
	"./CollectionShow/Articles/Articles": 1184,
	"./CollectionShow/Articles/Articles.jsx": 1184,
	"./CollectionShow/Articles/MultimediaCard": 1185,
	"./CollectionShow/Articles/MultimediaCard.jsx": 1185,
	"./CollectionShow/Authors/AuthorCard": 1186,
	"./CollectionShow/Authors/AuthorCard.jsx": 1186,
	"./CollectionShow/Authors/Authors": 1187,
	"./CollectionShow/Authors/Authors.jsx": 1187,
	"./CollectionShow/Hero": 1188,
	"./CollectionShow/Hero.jsx": 1188,
	"./CollectionShow/Index": 1853,
	"./CollectionShow/Index.jsx": 1853,
	"./CollectionShow/Overview/ArticleCard": 1194,
	"./CollectionShow/Overview/ArticleCard.jsx": 1194,
	"./CollectionShow/Overview/CollectionComments": 1195,
	"./CollectionShow/Overview/CollectionComments.jsx": 1195,
	"./CollectionShow/Overview/GuestEditor": 1197,
	"./CollectionShow/Overview/GuestEditor.jsx": 1197,
	"./CollectionShow/Overview/Overview": 1190,
	"./CollectionShow/Overview/Overview.jsx": 1190,
	"./CollectionShow/Overview/Question": 1192,
	"./CollectionShow/Overview/Question.jsx": 1192,
	"./CollectionShow/Overview/Questions": 1191,
	"./CollectionShow/Overview/Questions.jsx": 1191,
	"./CollectionShow/Overview/RecentArticles": 1193,
	"./CollectionShow/Overview/RecentArticles.jsx": 1193,
	"./CollectionShow/Overview/TopAuthor": 1196,
	"./CollectionShow/Overview/TopAuthor.jsx": 1196,
	"./CollectionShow/Tab": 1189,
	"./CollectionShow/Tab.jsx": 1189,
	"./Collections/ApplicationForm": 1854,
	"./Collections/ApplicationForm.jsx": 1854,
	"./Collections/BigCard": 1198,
	"./Collections/BigCard.jsx": 1198,
	"./Collections/ErrorMessage": 558,
	"./Collections/ErrorMessage.jsx": 558,
	"./Collections/Filters": 1199,
	"./Collections/Filters.jsx": 1199,
	"./Collections/Label": 53,
	"./Collections/Label.jsx": 53,
	"./Collections/Main": 1855,
	"./Collections/Main.jsx": 1855,
	"./Collections/SmallCard": 1200,
	"./Collections/SmallCard.jsx": 1200,
	"./CommentForm": 1856,
	"./CommentForm.js": 1856,
	"./CommentForm/Comment": 550,
	"./CommentForm/Comment.jsx": 550,
	"./CommentForm/CommentForm": 323,
	"./CommentForm/CommentForm.jsx": 323,
	"./CommentForm/FlagModal": 1061,
	"./CommentForm/FlagModal.jsx": 1061,
	"./CommentForm/Main": 322,
	"./CommentForm/Main.jsx": 322,
	"./CommentForm/SplitDropDownSort": 1062,
	"./CommentForm/SplitDropDownSort.jsx": 1062,
	"./ConfirmationModal": 66,
	"./ConfirmationModal.jsx": 66,
	"./ContactCoAuthors": 315,
	"./ContactCoAuthors.jsx": 315,
	"./ContactCoAuthorsModal": 1019,
	"./ContactCoAuthorsModal.jsx": 1019,
	"./ContentPerformance/DetailedPerformance": 1201,
	"./ContentPerformance/DetailedPerformance.jsx": 1201,
	"./ContentPerformance/Main": 1857,
	"./ContentPerformance/Main.jsx": 1857,
	"./ContentPerformance/Summary": 1202,
	"./ContentPerformance/Summary.jsx": 1202,
	"./ContentPost/SocialMedia/Main": 1858,
	"./ContentPost/SocialMedia/Main.jsx": 1858,
	"./ContentPost/SocialMedia/Table": 1203,
	"./ContentPost/SocialMedia/Table.jsx": 1203,
	"./CureusEditingServices": 1497,
	"./CureusEditingServices.js": 1497,
	"./CureusEditingServices/Button": 602,
	"./CureusEditingServices/Button.jsx": 602,
	"./CureusEditingServices/Calculator": 1498,
	"./CureusEditingServices/Calculator.jsx": 1498,
	"./CureusEditingServices/DropDown": 87,
	"./CureusEditingServices/DropDown.jsx": 87,
	"./Dashboard": 1859,
	"./Dashboard.js": 1859,
	"./Dashboard/ActionButton/AbandonModal": 330,
	"./Dashboard/ActionButton/AbandonModal.jsx": 330,
	"./Dashboard/ActionButton/Approved": 1204,
	"./Dashboard/ActionButton/Approved.jsx": 1204,
	"./Dashboard/ActionButton/Draft": 1207,
	"./Dashboard/ActionButton/Draft.jsx": 1207,
	"./Dashboard/ActionButton/InReview": 1208,
	"./Dashboard/ActionButton/InReview.jsx": 1208,
	"./Dashboard/ActionButton/PaidServiceModal": 173,
	"./Dashboard/ActionButton/PaidServiceModal.jsx": 173,
	"./Dashboard/ActionButton/PostDeferralOptionsModal": 1499,
	"./Dashboard/ActionButton/PostDeferralOptionsModal.jsx": 1499,
	"./Dashboard/ActionButton/RereviewsComplete": 1209,
	"./Dashboard/ActionButton/RereviewsComplete.jsx": 1209,
	"./Dashboard/ActionButton/ReviewsComplete": 1210,
	"./Dashboard/ActionButton/ReviewsComplete.jsx": 1210,
	"./Dashboard/ArticleDetails": 1860,
	"./Dashboard/ArticleDetails.jsx": 1860,
	"./Dashboard/ArticleStateDetails": 1211,
	"./Dashboard/ArticleStateDetails.jsx": 1211,
	"./Dashboard/CoauthorTool/CoauthorMain": 332,
	"./Dashboard/CoauthorTool/CoauthorMain.jsx": 332,
	"./Dashboard/CoauthorTool/Row": 1213,
	"./Dashboard/CoauthorTool/Row.jsx": 1213,
	"./Dashboard/EmailEditingServiceReceiptModal": 333,
	"./Dashboard/EmailEditingServiceReceiptModal.jsx": 333,
	"./Dashboard/Metrics/Main": 1861,
	"./Dashboard/Metrics/Main.jsx": 1861,
	"./Dashboard/ReviewsDashboard/ArticleNotifications": 1214,
	"./Dashboard/ReviewsDashboard/ArticleNotifications.jsx": 1214,
	"./Dashboard/ReviewsDashboard/CoauthorNotification": 1215,
	"./Dashboard/ReviewsDashboard/CoauthorNotification.jsx": 1215,
	"./Dashboard/ReviewsDashboard/Invite": 334,
	"./Dashboard/ReviewsDashboard/Invite.jsx": 334,
	"./Dashboard/ReviewsDashboard/Main": 1216,
	"./Dashboard/ReviewsDashboard/Main.jsx": 1216,
	"./Dashboard/ReviewsDashboard/NewModal": 335,
	"./Dashboard/ReviewsDashboard/NewModal.jsx": 335,
	"./Dashboard/ReviewsDashboard/OwnershipRating": 1206,
	"./Dashboard/ReviewsDashboard/OwnershipRating.jsx": 1206,
	"./Dashboard/ReviewsDashboard/PeerReviewProgress": 338,
	"./Dashboard/ReviewsDashboard/PeerReviewProgress.jsx": 338,
	"./Dashboard/ReviewsDashboard/RatingModal": 331,
	"./Dashboard/ReviewsDashboard/RatingModal.jsx": 331,
	"./Dashboard/ReviewsDashboard/RemindModal": 337,
	"./Dashboard/ReviewsDashboard/RemindModal.jsx": 337,
	"./Dashboard/ReviewsDashboard/RemindSpecificModal": 336,
	"./Dashboard/ReviewsDashboard/RemindSpecificModal.jsx": 336,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/LearnMoreModal": 532,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/LearnMoreModal.jsx": 532,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/QuickviewModal": 1218,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/QuickviewModal.jsx": 1218,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/ReviewerActivityMain": 339,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/ReviewerActivityMain.jsx": 339,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/Row": 1217,
	"./Dashboard/ReviewsDashboard/ReviewerActivity/Row.jsx": 1217,
	"./Dashboard/ReviewsDashboard/ReviewerRating": 1205,
	"./Dashboard/ReviewsDashboard/ReviewerRating.jsx": 1205,
	"./Dashboard/ReviewsDashboard/SuperMain": 1862,
	"./Dashboard/ReviewsDashboard/SuperMain.jsx": 1862,
	"./Dashboard/StateHistoryModal": 127,
	"./Dashboard/StateHistoryModal.jsx": 127,
	"./Dashboard/StateHistoryRow": 1212,
	"./Dashboard/StateHistoryRow.jsx": 1212,
	"./DeferralReasons": 1863,
	"./DeferralReasons.js": 1863,
	"./DeferralReasons/DeferralModal": 1219,
	"./DeferralReasons/DeferralModal.jsx": 1219,
	"./DeferralReasons/Main": 1864,
	"./DeferralReasons/Main.jsx": 1864,
	"./DeferralReasons/MainModal": 1220,
	"./DeferralReasons/MainModal.jsx": 1220,
	"./DeferralReasons/PreferredChoiceModal": 1221,
	"./DeferralReasons/PreferredChoiceModal.jsx": 1221,
	"./DeskRejectedModal": 1222,
	"./DeskRejectedModal.jsx": 1222,
	"./DiscountWidget/Main": 1865,
	"./DiscountWidget/Main.jsx": 1865,
	"./Discussions/AddModal": 284,
	"./Discussions/AddModal.jsx": 284,
	"./Discussions/DiscussionCard": 283,
	"./Discussions/DiscussionCard.jsx": 283,
	"./Discussions/HomepageContainer": 924,
	"./Discussions/HomepageContainer.jsx": 924,
	"./Discussions/Index": 282,
	"./Discussions/Index.jsx": 282,
	"./DiversityTool": 1866,
	"./DiversityTool.js": 1866,
	"./DiversityTool/Author": 207,
	"./DiversityTool/Author.jsx": 207,
	"./DiversityTool/Main": 285,
	"./DiversityTool/Main.jsx": 285,
	"./DiversityTool/Reviewer": 208,
	"./DiversityTool/Reviewer.jsx": 208,
	"./DropdownNav": 1867,
	"./DropdownNav.jsx": 1867,
	"./EditorActivity/ApprovalCompleted": 1223,
	"./EditorActivity/ApprovalCompleted.jsx": 1223,
	"./EditorActivity/ApprovalMatches": 1224,
	"./EditorActivity/ApprovalMatches.jsx": 1224,
	"./EditorActivity/ApprovalRating": 1225,
	"./EditorActivity/ApprovalRating.jsx": 1225,
	"./EditorActivity/AverageScores": 1226,
	"./EditorActivity/AverageScores.jsx": 1226,
	"./EditorActivity/CompletedRow": 31,
	"./EditorActivity/CompletedRow.jsx": 31,
	"./EditorActivity/CopyCompleted": 1227,
	"./EditorActivity/CopyCompleted.jsx": 1227,
	"./EditorActivity/DualCompleted": 1228,
	"./EditorActivity/DualCompleted.jsx": 1228,
	"./EditorActivity/Main": 1868,
	"./EditorActivity/Main.jsx": 1868,
	"./EditorActivity/MessagesCommentsToAuthor": 559,
	"./EditorActivity/MessagesCommentsToAuthor.jsx": 559,
	"./EditorActivity/RejectedReviews": 1230,
	"./EditorActivity/RejectedReviews.jsx": 1230,
	"./EditorActivity/SubmissionsCompleted": 1229,
	"./EditorActivity/SubmissionsCompleted.jsx": 1229,
	"./EditorArticleRating": 1869,
	"./EditorArticleRating.js": 1869,
	"./EditorArticleRating/BlockOrDesk": 560,
	"./EditorArticleRating/BlockOrDesk.jsx": 560,
	"./EditorArticleRating/CheckListBlock": 1232,
	"./EditorArticleRating/CheckListBlock.jsx": 1232,
	"./EditorArticleRating/CheckListDesk": 1231,
	"./EditorArticleRating/CheckListDesk.jsx": 1231,
	"./EditorArticleRating/ChecklistItem": 36,
	"./EditorArticleRating/ChecklistItem.jsx": 36,
	"./EditorArticleRating/Deferral": 1233,
	"./EditorArticleRating/Deferral.jsx": 1233,
	"./EditorArticleRating/EarModal": 1234,
	"./EditorArticleRating/EarModal.jsx": 1234,
	"./EditorArticleRating/Email": 1235,
	"./EditorArticleRating/Email.jsx": 1235,
	"./EditorArticleRating/Main": 1870,
	"./EditorArticleRating/Main.jsx": 1870,
	"./EditorArticleRating/OAChecklistItem": 91,
	"./EditorArticleRating/OAChecklistItem.jsx": 91,
	"./EditorArticleRating/OriginalArticleStep": 1236,
	"./EditorArticleRating/OriginalArticleStep.jsx": 1236,
	"./EditorArticleRating/Slider": 131,
	"./EditorArticleRating/Slider.jsx": 131,
	"./EditorGoals/DualRow": 1237,
	"./EditorGoals/DualRow.jsx": 1237,
	"./EditorGoals/Row": 1238,
	"./EditorGoals/Row.jsx": 1238,
	"./EditorGoals/Table": 1871,
	"./EditorGoals/Table.jsx": 1871,
	"./EditorialBoard": 1500,
	"./EditorialBoard.js": 1500,
	"./EditorialBoard/Editor": 377,
	"./EditorialBoard/Editor.jsx": 377,
	"./EditorialBoard/Main": 1501,
	"./EditorialBoard/Main.jsx": 1501,
	"./EditorialBoard/Sidebar": 247,
	"./EditorialBoard/Sidebar.jsx": 247,
	"./EditorialSettings/CopyPeRatio": 1872,
	"./EditorialSettings/CopyPeRatio.jsx": 1872,
	"./Editors/EditorAnnouncement": 1873,
	"./Editors/EditorAnnouncement.jsx": 1873,
	"./Editors/EditorMessagesDashboard/ClosedTable": 1239,
	"./Editors/EditorMessagesDashboard/ClosedTable.jsx": 1239,
	"./Editors/EditorMessagesDashboard/EditorMessagesTable": 340,
	"./Editors/EditorMessagesDashboard/EditorMessagesTable.jsx": 340,
	"./Editors/EditorMessagesDashboard/Main": 1874,
	"./Editors/EditorMessagesDashboard/Main.jsx": 1874,
	"./Editors/EditorMessagesDashboard/MessageStatusModal": 1240,
	"./Editors/EditorMessagesDashboard/MessageStatusModal.jsx": 1240,
	"./Editors/EditorMessagesDashboard/OpenTable": 1241,
	"./Editors/EditorMessagesDashboard/OpenTable.jsx": 1241,
	"./EmailCampaignIndex": 1875,
	"./EmailCampaignIndex.js": 1875,
	"./EmailCampaignIndex/ActionSplitButtons": 1242,
	"./EmailCampaignIndex/ActionSplitButtons.jsx": 1242,
	"./EmailCampaignIndex/CampaignRow": 1243,
	"./EmailCampaignIndex/CampaignRow.jsx": 1243,
	"./EmailCampaignIndex/CreateCampaignModal": 1245,
	"./EmailCampaignIndex/CreateCampaignModal.jsx": 1245,
	"./EmailCampaignIndex/DeleteButton": 1246,
	"./EmailCampaignIndex/DeleteButton.jsx": 1246,
	"./EmailCampaignIndex/DeleteCampaignsModal": 1247,
	"./EmailCampaignIndex/DeleteCampaignsModal.jsx": 1247,
	"./EmailCampaignIndex/Filter": 1248,
	"./EmailCampaignIndex/Filter.jsx": 1248,
	"./EmailCampaignIndex/Main": 1876,
	"./EmailCampaignIndex/Main.jsx": 1876,
	"./EmailCampaignIndex/RenameCampaignModal": 1244,
	"./EmailCampaignIndex/RenameCampaignModal.jsx": 1244,
	"./EmailCampaignIndex/TemplateFilter": 172,
	"./EmailCampaignIndex/TemplateFilter.jsx": 172,
	"./EmailCampaignIndex/UpdateStatsButton": 1249,
	"./EmailCampaignIndex/UpdateStatsButton.jsx": 1249,
	"./EmailListIndex": 1877,
	"./EmailListIndex.js": 1877,
	"./EmailListIndex/BulkActions": 1250,
	"./EmailListIndex/BulkActions.jsx": 1250,
	"./EmailListIndex/BulkAddModal": 561,
	"./EmailListIndex/BulkAddModal.jsx": 561,
	"./EmailListIndex/BulkDeleteModal": 1252,
	"./EmailListIndex/BulkDeleteModal.jsx": 1252,
	"./EmailListIndex/BulkExportModal": 1253,
	"./EmailListIndex/BulkExportModal.jsx": 1253,
	"./EmailListIndex/ChannelMain": 1878,
	"./EmailListIndex/ChannelMain.jsx": 1878,
	"./EmailListIndex/CheckboxToggler": 1254,
	"./EmailListIndex/CheckboxToggler.jsx": 1254,
	"./EmailListIndex/CreateList": 341,
	"./EmailListIndex/CreateList.jsx": 341,
	"./EmailListIndex/CreateListModal": 342,
	"./EmailListIndex/CreateListModal.jsx": 342,
	"./EmailListIndex/ExportCsvModal": 1255,
	"./EmailListIndex/ExportCsvModal.jsx": 1255,
	"./EmailListIndex/LockedListSelectedModal": 1251,
	"./EmailListIndex/LockedListSelectedModal.jsx": 1251,
	"./EmailListIndex/Main": 1879,
	"./EmailListIndex/Main.jsx": 1879,
	"./EmailListIndex/Row": 1259,
	"./EmailListIndex/Row.jsx": 1259,
	"./EmailListIndex/Search": 1257,
	"./EmailListIndex/Search.jsx": 1257,
	"./EmailListIndex/Sorter": 1256,
	"./EmailListIndex/Sorter.jsx": 1256,
	"./EmailListIndex/Table": 1258,
	"./EmailListIndex/Table.jsx": 1258,
	"./EmailTool": 89,
	"./EmailTool.js": 89,
	"./EmailTool/AddDropdown": 1263,
	"./EmailTool/AddDropdown.jsx": 1263,
	"./EmailTool/AddFromCureus": 1264,
	"./EmailTool/AddFromCureus.jsx": 1264,
	"./EmailTool/AddFromCureusMain": 1880,
	"./EmailTool/AddFromCureusMain.jsx": 1880,
	"./EmailTool/AddFromExisting": 1881,
	"./EmailTool/AddFromExisting.jsx": 1881,
	"./EmailTool/AddFromExistingModal": 1273,
	"./EmailTool/AddFromExistingModal.jsx": 1273,
	"./EmailTool/AddFromPmcModal": 1274,
	"./EmailTool/AddFromPmcModal.jsx": 1274,
	"./EmailTool/AddPersonModal": 1275,
	"./EmailTool/AddPersonModal.jsx": 1275,
	"./EmailTool/AddToList": 1265,
	"./EmailTool/AddToList.jsx": 1265,
	"./EmailTool/AddToRefresh": 1266,
	"./EmailTool/AddToRefresh.jsx": 1266,
	"./EmailTool/AllInviteesTable": 1276,
	"./EmailTool/AllInviteesTable.jsx": 1276,
	"./EmailTool/DeleteListEmailsModal": 1277,
	"./EmailTool/DeleteListEmailsModal.jsx": 1277,
	"./EmailTool/EmailListRefreshes": 1278,
	"./EmailTool/EmailListRefreshes.jsx": 1278,
	"./EmailTool/EmailListTable": 1279,
	"./EmailTool/EmailListTable.jsx": 1279,
	"./EmailTool/Filter": 1268,
	"./EmailTool/Filter.jsx": 1268,
	"./EmailTool/FilterControl": 1272,
	"./EmailTool/FilterControl.jsx": 1272,
	"./EmailTool/FilterNotification": 1269,
	"./EmailTool/FilterNotification.jsx": 1269,
	"./EmailTool/FilterTool": 1267,
	"./EmailTool/FilterTool.jsx": 1267,
	"./EmailTool/FilterableTable": 1270,
	"./EmailTool/FilterableTable.jsx": 1270,
	"./EmailTool/LengthControl": 1271,
	"./EmailTool/LengthControl.jsx": 1271,
	"./EmailTool/LockedTable": 1280,
	"./EmailTool/LockedTable.jsx": 1280,
	"./EmailTool/Search": 174,
	"./EmailTool/Search.jsx": 174,
	"./EmailTool/SubscribedFilter": 175,
	"./EmailTool/SubscribedFilter.jsx": 175,
	"./EmailTool/SwitchList": 1882,
	"./EmailTool/SwitchList.jsx": 1882,
	"./EmailTool/Table": 128,
	"./EmailTool/Table.jsx": 128,
	"./EmailTool/UploadFileModal": 343,
	"./EmailTool/UploadFileModal.jsx": 343,
	"./EmailTool/UploadUsers": 1883,
	"./EmailTool/UploadUsers.jsx": 1883,
	"./EmailTool/ViewAllChannelInvitees": 1884,
	"./EmailTool/ViewAllChannelInvitees.jsx": 1884,
	"./EmailTool/ViewChannelList": 1885,
	"./EmailTool/ViewChannelList.jsx": 1885,
	"./EmailTool/ViewList": 1886,
	"./EmailTool/ViewList.jsx": 1886,
	"./EmailTool/ViewableTable": 1281,
	"./EmailTool/ViewableTable.jsx": 1281,
	"./EmailTool/buttons": 925,
	"./EmailTool/buttons.js": 925,
	"./EmailTool/fluxxor/actions": 1262,
	"./EmailTool/fluxxor/actions.js": 1262,
	"./EmailTool/fluxxor/constants": 33,
	"./EmailTool/fluxxor/constants.js": 33,
	"./EmailTool/fluxxor/stores/FilterTool": 1261,
	"./EmailTool/fluxxor/stores/FilterTool.js": 1261,
	"./EmailTool/fluxxor/stores/Table": 1260,
	"./EmailTool/fluxxor/stores/Table.js": 1260,
	"./FeaturedArticles": 1887,
	"./FeaturedArticles.js": 1887,
	"./FeaturedArticles/Card": 1282,
	"./FeaturedArticles/Card.jsx": 1282,
	"./FeaturedArticles/CategorySelector": 1283,
	"./FeaturedArticles/CategorySelector.jsx": 1283,
	"./FeaturedArticles/Content": 1284,
	"./FeaturedArticles/Content.jsx": 1284,
	"./FeaturedArticles/Main": 1888,
	"./FeaturedArticles/Main.jsx": 1888,
	"./FeaturedMultimedia/Main": 254,
	"./FeaturedMultimedia/Main.jsx": 254,
	"./FeaturedMultimedia/MultimediaCard": 255,
	"./FeaturedMultimedia/MultimediaCard.jsx": 255,
	"./FileDrop": 1082,
	"./FileDrop.jsx": 1082,
	"./FinancialRelationships": 1889,
	"./FinancialRelationships.js": 1889,
	"./FinancialRelationships/AddDisclosureModal": 344,
	"./FinancialRelationships/AddDisclosureModal.jsx": 344,
	"./FinancialRelationships/RelationshipRow": 1285,
	"./FinancialRelationships/RelationshipRow.jsx": 1285,
	"./FinancialRelationships/RelationshipRows": 1890,
	"./FinancialRelationships/RelationshipRows.jsx": 1890,
	"./Forms": 1891,
	"./Forms.js": 1891,
	"./Forms/Post": 1286,
	"./Forms/Post.jsx": 1286,
	"./GettingStarted": 1892,
	"./GettingStarted.jsx": 1892,
	"./Guides/AcademicChannelGuide": 378,
	"./Guides/AcademicChannelGuide.jsx": 378,
	"./Guides/AcademicChannelsPages/ChannelEditorialResponsibilities": 383,
	"./Guides/AcademicChannelsPages/ChannelEditorialResponsibilities.jsx": 383,
	"./Guides/AcademicChannelsPages/ChannelEditorialRoles": 382,
	"./Guides/AcademicChannelsPages/ChannelEditorialRoles.jsx": 382,
	"./Guides/AcademicChannelsPages/Faq": 381,
	"./Guides/AcademicChannelsPages/Faq.jsx": 381,
	"./Guides/AcademicChannelsPages/Introduction": 380,
	"./Guides/AcademicChannelsPages/Introduction.jsx": 380,
	"./Guides/AuthorGuide": 384,
	"./Guides/AuthorGuide.jsx": 384,
	"./Guides/AuthorPages/AcceptedArticleTypes": 387,
	"./Guides/AuthorPages/AcceptedArticleTypes.jsx": 387,
	"./Guides/AuthorPages/ArtificialIntelligence": 402,
	"./Guides/AuthorPages/ArtificialIntelligence.jsx": 402,
	"./Guides/AuthorPages/AuthorRoles": 390,
	"./Guides/AuthorPages/AuthorRoles.jsx": 390,
	"./Guides/AuthorPages/BusinessModel": 411,
	"./Guides/AuthorPages/BusinessModel.jsx": 411,
	"./Guides/AuthorPages/CommentingPolicies": 408,
	"./Guides/AuthorPages/CommentingPolicies.jsx": 408,
	"./Guides/AuthorPages/Confidentiality": 407,
	"./Guides/AuthorPages/Confidentiality.jsx": 407,
	"./Guides/AuthorPages/ConflictsOfInterest": 399,
	"./Guides/AuthorPages/ConflictsOfInterest.jsx": 399,
	"./Guides/AuthorPages/CopyrightAndLicensing": 409,
	"./Guides/AuthorPages/CopyrightAndLicensing.jsx": 409,
	"./Guides/AuthorPages/DataCitationAndTransparency": 403,
	"./Guides/AuthorPages/DataCitationAndTransparency.jsx": 403,
	"./Guides/AuthorPages/DisciplineSpecificStandards": 406,
	"./Guides/AuthorPages/DisciplineSpecificStandards.jsx": 406,
	"./Guides/AuthorPages/FreePublication": 386,
	"./Guides/AuthorPages/FreePublication.jsx": 386,
	"./Guides/AuthorPages/HumanAndAnimalSubjects": 400,
	"./Guides/AuthorPages/HumanAndAnimalSubjects.jsx": 400,
	"./Guides/AuthorPages/IcmjeRequirements": 397,
	"./Guides/AuthorPages/IcmjeRequirements.jsx": 397,
	"./Guides/AuthorPages/Introduction": 385,
	"./Guides/AuthorPages/Introduction.jsx": 385,
	"./Guides/AuthorPages/ManagingPeerReview": 392,
	"./Guides/AuthorPages/ManagingPeerReview.jsx": 392,
	"./Guides/AuthorPages/PlagiarismMisconductAndEthics": 398,
	"./Guides/AuthorPages/PlagiarismMisconductAndEthics.jsx": 398,
	"./Guides/AuthorPages/Preregistration": 404,
	"./Guides/AuthorPages/Preregistration.jsx": 404,
	"./Guides/AuthorPages/PromotingYourResearch": 395,
	"./Guides/AuthorPages/PromotingYourResearch.jsx": 395,
	"./Guides/AuthorPages/RaceAndEthnicity": 401,
	"./Guides/AuthorPages/RaceAndEthnicity.jsx": 401,
	"./Guides/AuthorPages/References": 393,
	"./Guides/AuthorPages/References.jsx": 393,
	"./Guides/AuthorPages/ReplicationStudies": 405,
	"./Guides/AuthorPages/ReplicationStudies.jsx": 405,
	"./Guides/AuthorPages/RetractionPolicy": 410,
	"./Guides/AuthorPages/RetractionPolicy.jsx": 410,
	"./Guides/AuthorPages/SeoTips": 394,
	"./Guides/AuthorPages/SeoTips.jsx": 394,
	"./Guides/AuthorPages/SingleBlindedPeerReview": 396,
	"./Guides/AuthorPages/SingleBlindedPeerReview.jsx": 396,
	"./Guides/AuthorPages/StepByStepOverview": 389,
	"./Guides/AuthorPages/StepByStepOverview.jsx": 389,
	"./Guides/AuthorPages/SubmittingAnArticle": 391,
	"./Guides/AuthorPages/SubmittingAnArticle.jsx": 391,
	"./Guides/AuthorPages/UnacceptedArticleTypes": 388,
	"./Guides/AuthorPages/UnacceptedArticleTypes.jsx": 388,
	"./Guides/Card": 86,
	"./Guides/Card.jsx": 86,
	"./Guides/Footer": 160,
	"./Guides/Footer.jsx": 160,
	"./Guides/GuestEditorGuide": 412,
	"./Guides/GuestEditorGuide.jsx": 412,
	"./Guides/GuestEditorPages/FrequentlyAskedQuestions": 416,
	"./Guides/GuestEditorPages/FrequentlyAskedQuestions.jsx": 416,
	"./Guides/GuestEditorPages/GettingStarted": 414,
	"./Guides/GuestEditorPages/GettingStarted.jsx": 414,
	"./Guides/GuestEditorPages/Introduction": 413,
	"./Guides/GuestEditorPages/Introduction.jsx": 413,
	"./Guides/GuestEditorPages/StepByStepInstructions": 415,
	"./Guides/GuestEditorPages/StepByStepInstructions.jsx": 415,
	"./Guides/Main": 1502,
	"./Guides/Main.jsx": 1502,
	"./Guides/MediaGuide": 417,
	"./Guides/MediaGuide.jsx": 417,
	"./Guides/MediaPages/AddingFigures": 422,
	"./Guides/MediaPages/AddingFigures.jsx": 422,
	"./Guides/MediaPages/AddingInteractiveModels": 429,
	"./Guides/MediaPages/AddingInteractiveModels.jsx": 429,
	"./Guides/MediaPages/AddingMedia": 418,
	"./Guides/MediaPages/AddingMedia.jsx": 418,
	"./Guides/MediaPages/AddingTables": 426,
	"./Guides/MediaPages/AddingTables.jsx": 426,
	"./Guides/MediaPages/AddingVideos": 428,
	"./Guides/MediaPages/AddingVideos.jsx": 428,
	"./Guides/MediaPages/FigureRequirements": 421,
	"./Guides/MediaPages/FigureRequirements.jsx": 421,
	"./Guides/MediaPages/GenerativeAiImages": 424,
	"./Guides/MediaPages/GenerativeAiImages.jsx": 424,
	"./Guides/MediaPages/MentioningMedia": 420,
	"./Guides/MediaPages/MentioningMedia.jsx": 420,
	"./Guides/MediaPages/PrivacyAndPermissionIssues": 430,
	"./Guides/MediaPages/PrivacyAndPermissionIssues.jsx": 430,
	"./Guides/MediaPages/TableRequirements": 425,
	"./Guides/MediaPages/TableRequirements.jsx": 425,
	"./Guides/MediaPages/TitleLegendsNumbering": 419,
	"./Guides/MediaPages/TitleLegendsNumbering.jsx": 419,
	"./Guides/MediaPages/UnacceptableFigureExamples": 423,
	"./Guides/MediaPages/UnacceptableFigureExamples.jsx": 423,
	"./Guides/MediaPages/UnacceptableTableExamples": 427,
	"./Guides/MediaPages/UnacceptableTableExamples.jsx": 427,
	"./Guides/Page": 1503,
	"./Guides/Page.jsx": 1503,
	"./Guides/ResultCard": 379,
	"./Guides/ResultCard.jsx": 379,
	"./Guides/ReviewerGuide": 431,
	"./Guides/ReviewerGuide.jsx": 431,
	"./Guides/ReviewerPages/Introduction": 436,
	"./Guides/ReviewerPages/Introduction.jsx": 436,
	"./Guides/ReviewerPages/RereviewProcess": 434,
	"./Guides/ReviewerPages/RereviewProcess.jsx": 434,
	"./Guides/ReviewerPages/StepByStepOverview": 433,
	"./Guides/ReviewerPages/StepByStepOverview.jsx": 433,
	"./Guides/ReviewerPages/SuspectPlagiarism": 435,
	"./Guides/ReviewerPages/SuspectPlagiarism.jsx": 435,
	"./Guides/ReviewerPages/WhyReviewWithCureus": 432,
	"./Guides/ReviewerPages/WhyReviewWithCureus.jsx": 432,
	"./Guides/Root": 1504,
	"./Guides/Root.jsx": 1504,
	"./Guides/SearchBar": 84,
	"./Guides/SearchBar.jsx": 84,
	"./Guides/SearchResults": 46,
	"./Guides/SearchResults.jsx": 46,
	"./Guides/SideNavMenu": 162,
	"./Guides/SideNavMenu.jsx": 162,
	"./Guides/TopNavMenu": 161,
	"./Guides/TopNavMenu.jsx": 161,
	"./History": 1893,
	"./History.js": 1893,
	"./History/HistoryModal": 17,
	"./History/HistoryModal.jsx": 17,
	"./History/Main": 1894,
	"./History/Main.jsx": 1894,
	"./Home/ArticleCard": 81,
	"./Home/ArticleCard.jsx": 81,
	"./Home/CureusUCard": 83,
	"./Home/CureusUCard.jsx": 83,
	"./Home/CureusUpdates": 220,
	"./Home/CureusUpdates.jsx": 220,
	"./Home/CureusUpdatesHistoryTable": 926,
	"./Home/CureusUpdatesHistoryTable.jsx": 926,
	"./Home/FeaturedContent": 216,
	"./Home/FeaturedContent.jsx": 216,
	"./Home/FeaturedContentCard": 217,
	"./Home/FeaturedContentCard.jsx": 217,
	"./Home/FeaturedContentCarousel": 927,
	"./Home/FeaturedContentCarousel.jsx": 927,
	"./Home/FeaturedContentModal": 218,
	"./Home/FeaturedContentModal.jsx": 218,
	"./Home/MetricsCard": 80,
	"./Home/MetricsCard.jsx": 80,
	"./Home/NewsCard": 82,
	"./Home/NewsCard.jsx": 82,
	"./Home/Search": 928,
	"./Home/Search.jsx": 928,
	"./Home/VideoImage": 929,
	"./Home/VideoImage.jsx": 929,
	"./Home/VideoModal": 222,
	"./Home/VideoModal.jsx": 222,
	"./HomepageFeaturedArticles/Card": 356,
	"./HomepageFeaturedArticles/Card.jsx": 356,
	"./HomepageFeaturedArticles/Content": 223,
	"./HomepageFeaturedArticles/Content.jsx": 223,
	"./HomepageFeaturedArticles/Main": 930,
	"./HomepageFeaturedArticles/Main.jsx": 930,
	"./HomepageHeros": 931,
	"./HomepageHeros.js": 931,
	"./HomepageHeros/DeleteHeroModal": 215,
	"./HomepageHeros/DeleteHeroModal.jsx": 215,
	"./HomepageHeros/Hero": 214,
	"./HomepageHeros/Hero.jsx": 214,
	"./HomepageHeros/Main": 213,
	"./HomepageHeros/Main.jsx": 213,
	"./HomepageV2/Discussions/Main": 932,
	"./HomepageV2/Discussions/Main.jsx": 932,
	"./HomepageV2/Discussions/NewDiscussionCard": 224,
	"./HomepageV2/Discussions/NewDiscussionCard.jsx": 224,
	"./HomepageV2/FeaturedMultiMedia/Main": 933,
	"./HomepageV2/FeaturedMultiMedia/Main.jsx": 933,
	"./HomepageV2Carousel/HomepageCarousel": 934,
	"./HomepageV2Carousel/HomepageCarousel.jsx": 934,
	"./HomepageV2Carousel/Slide": 225,
	"./HomepageV2Carousel/Slide.jsx": 225,
	"./Howto": 1895,
	"./Howto.js": 1895,
	"./Howto/Abstract": 1287,
	"./Howto/Abstract.jsx": 1287,
	"./Howto/ArticleCitations": 1288,
	"./Howto/ArticleCitations.jsx": 1288,
	"./Howto/ArticleMedia": 1289,
	"./Howto/ArticleMedia.jsx": 1289,
	"./Howto/ArticleSubheaders": 1290,
	"./Howto/ArticleSubheaders.jsx": 1290,
	"./Howto/Authors": 1291,
	"./Howto/Authors.jsx": 1291,
	"./Howto/Close": 1292,
	"./Howto/Close.jsx": 1292,
	"./Howto/Content": 1293,
	"./Howto/Content.jsx": 1293,
	"./Howto/Keywords": 1294,
	"./Howto/Keywords.jsx": 1294,
	"./Howto/Main": 1896,
	"./Howto/Main.jsx": 1896,
	"./Howto/MediaMentions": 1295,
	"./Howto/MediaMentions.jsx": 1295,
	"./Howto/MinMax": 1301,
	"./Howto/MinMax.jsx": 1301,
	"./Howto/Nav": 1296,
	"./Howto/Nav.jsx": 1296,
	"./Howto/Next": 1297,
	"./Howto/Next.jsx": 1297,
	"./Howto/Prev": 1298,
	"./Howto/Prev.jsx": 1298,
	"./Howto/Range": 1299,
	"./Howto/Range.jsx": 1299,
	"./Howto/Title": 562,
	"./Howto/Title.jsx": 562,
	"./Howto/TopBar": 1300,
	"./Howto/TopBar.jsx": 1300,
	"./HumanSubjects": 1897,
	"./HumanSubjects.js": 1897,
	"./HumanSubjects/UploadProofModal": 1302,
	"./HumanSubjects/UploadProofModal.jsx": 1302,
	"./HumanSubjects/Validator": 1898,
	"./HumanSubjects/Validator.jsx": 1898,
	"./ImageUploader": 1899,
	"./ImageUploader.js": 1899,
	"./ImageUploader/V1": 1900,
	"./ImageUploader/V1.jsx": 1900,
	"./ImageUploader/V2": 1901,
	"./ImageUploader/V2.jsx": 1901,
	"./InstitutionCarousel/Main": 1505,
	"./InstitutionCarousel/Main.jsx": 1505,
	"./InstitutionCarousel/Post": 437,
	"./InstitutionCarousel/Post.jsx": 437,
	"./Judgeship": 1902,
	"./Judgeship.js": 1902,
	"./Judgeship/JudgeInputField": 1303,
	"./Judgeship/JudgeInputField.jsx": 1303,
	"./Judgeship/JudgeRows": 1304,
	"./Judgeship/JudgeRows.jsx": 1304,
	"./Judgeship/JudgeshipModal": 1305,
	"./Judgeship/JudgeshipModal.jsx": 1305,
	"./Judgeship/Main": 1903,
	"./Judgeship/Main.jsx": 1903,
	"./KeywordTool": 1431,
	"./KeywordTool.jsx": 1431,
	"./Likes/LikeUser": 536,
	"./Likes/LikeUser.jsx": 536,
	"./Likes/Modal": 276,
	"./Likes/Modal.jsx": 276,
	"./Media": 1904,
	"./Media.js": 1904,
	"./Media/AttachmentInsertMixin": 129,
	"./Media/AttachmentInsertMixin.js": 129,
	"./Media/AttachmentUploadMixin": 345,
	"./Media/AttachmentUploadMixin.js": 345,
	"./Media/CheckList": 1306,
	"./Media/CheckList.jsx": 1306,
	"./Media/Details": 130,
	"./Media/Details.jsx": 130,
	"./Media/Edit": 1307,
	"./Media/Edit.jsx": 1307,
	"./Media/EditorModalTrigger": 1905,
	"./Media/EditorModalTrigger.jsx": 1905,
	"./Media/Errors": 176,
	"./Media/Errors.jsx": 176,
	"./Media/Figure": 1309,
	"./Media/Figure.jsx": 1309,
	"./Media/InteractiveModel": 1312,
	"./Media/InteractiveModel.jsx": 1312,
	"./Media/Table": 1310,
	"./Media/Table.jsx": 1310,
	"./Media/TooManyAttachments": 1308,
	"./Media/TooManyAttachments.jsx": 1308,
	"./Media/Video": 1311,
	"./Media/Video.jsx": 1311,
	"./MediaLibrary": 1906,
	"./MediaLibrary.js": 1906,
	"./MediaLibrary/AttachmentUploadMixin": 1907,
	"./MediaLibrary/AttachmentUploadMixin.js": 1907,
	"./MediaLibrary/DeleteModal": 1313,
	"./MediaLibrary/DeleteModal.jsx": 1313,
	"./MediaLibrary/DeleteModalTrigger": 1908,
	"./MediaLibrary/DeleteModalTrigger.jsx": 1908,
	"./Misc": 1909,
	"./Misc.js": 1909,
	"./Misc/Authorships": 938,
	"./Misc/Authorships.jsx": 938,
	"./Misc/PublishingConfirmationModal": 1438,
	"./Misc/PublishingConfirmationModal.jsx": 1438,
	"./Misc/References": 937,
	"./Misc/References.jsx": 937,
	"./Modal": 3,
	"./Modal.jsx": 3,
	"./MostPopularArticles/Card": 135,
	"./MostPopularArticles/Card.jsx": 135,
	"./MostPopularArticles/Index": 1506,
	"./MostPopularArticles/Index.jsx": 1506,
	"./MultiAdd/Main": 1910,
	"./MultiAdd/Main.jsx": 1910,
	"./MultiAdd/Row": 1314,
	"./MultiAdd/Row.jsx": 1314,
	"./NewArticleIndex/ArticleDateSelector": 132,
	"./NewArticleIndex/ArticleDateSelector.jsx": 132,
	"./NewArticleIndex/FiltersModal": 438,
	"./NewArticleIndex/FiltersModal.jsx": 438,
	"./NewArticleIndex/Header": 202,
	"./NewArticleIndex/Header.jsx": 202,
	"./NewArticleIndex/LeftSidebar/Carat": 164,
	"./NewArticleIndex/LeftSidebar/Carat.jsx": 164,
	"./NewArticleIndex/LeftSidebar/Categories": 439,
	"./NewArticleIndex/LeftSidebar/Categories.jsx": 439,
	"./NewArticleIndex/LeftSidebar/Filters": 163,
	"./NewArticleIndex/LeftSidebar/Filters.jsx": 163,
	"./NewArticleIndex/LeftSidebar/Sidebar": 442,
	"./NewArticleIndex/LeftSidebar/Sidebar.jsx": 442,
	"./NewArticleIndex/LeftSidebar/SpecialtyPromotion": 443,
	"./NewArticleIndex/LeftSidebar/SpecialtyPromotion.jsx": 443,
	"./NewArticleIndex/LeftSidebar/Types": 440,
	"./NewArticleIndex/LeftSidebar/Types.jsx": 440,
	"./NewArticleIndex/Main": 1507,
	"./NewArticleIndex/Main.jsx": 1507,
	"./NewArticleIndex/NewAdvancedSearch": 449,
	"./NewArticleIndex/NewAdvancedSearch.jsx": 449,
	"./NewArticleIndex/NewAdvancedSearchRow": 450,
	"./NewArticleIndex/NewAdvancedSearchRow.jsx": 450,
	"./NewArticleIndex/NewSearch": 448,
	"./NewArticleIndex/NewSearch.jsx": 448,
	"./NewArticleIndex/RightSidebar/Authors": 203,
	"./NewArticleIndex/RightSidebar/Authors.jsx": 203,
	"./NewArticleIndex/RightSidebar/Contributors": 445,
	"./NewArticleIndex/RightSidebar/Contributors.jsx": 445,
	"./NewArticleIndex/RightSidebar/PictureBubbles": 446,
	"./NewArticleIndex/RightSidebar/PictureBubbles.jsx": 446,
	"./NewArticleIndex/RightSidebar/PopularArticles": 447,
	"./NewArticleIndex/RightSidebar/PopularArticles.jsx": 447,
	"./NewArticleIndex/RightSidebar/Reviewers": 204,
	"./NewArticleIndex/RightSidebar/Reviewers.jsx": 204,
	"./NewArticleIndex/RightSidebar/Sidebar": 444,
	"./NewArticleIndex/RightSidebar/Sidebar.jsx": 444,
	"./NewArticleIndex/RightSidebar/TrendingTopics": 133,
	"./NewArticleIndex/RightSidebar/TrendingTopics.jsx": 133,
	"./NewArticleIndex/SortButton": 451,
	"./NewArticleIndex/SortButton.jsx": 451,
	"./NewArticleIndex/SubscribeButton": 441,
	"./NewArticleIndex/SubscribeButton.jsx": 441,
	"./NewCollectionsDashboard/ApproveOrRejectModal": 1315,
	"./NewCollectionsDashboard/ApproveOrRejectModal.jsx": 1315,
	"./NewCollectionsDashboard/ColleagueInvitationModal": 1316,
	"./NewCollectionsDashboard/ColleagueInvitationModal.jsx": 1316,
	"./NewCollectionsDashboard/InfoWidget": 1317,
	"./NewCollectionsDashboard/InfoWidget.jsx": 1317,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetCollectionApplication": 1320,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetCollectionApplication.jsx": 1320,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetInviteAndMetrics": 1318,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetInviteAndMetrics.jsx": 1318,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetStart": 1319,
	"./NewCollectionsDashboard/InfoWidgetViews/InfoWidgetStart.jsx": 1319,
	"./NewCollectionsDashboard/Main": 1911,
	"./NewCollectionsDashboard/Main.jsx": 1911,
	"./NewCollectionsDashboard/MyCollections": 1321,
	"./NewCollectionsDashboard/MyCollections.jsx": 1321,
	"./NewCollectionsDashboard/PendingArticles/PendingArticleRow": 1331,
	"./NewCollectionsDashboard/PendingArticles/PendingArticleRow.jsx": 1331,
	"./NewCollectionsDashboard/PendingArticles/PendingArticlesTab": 1330,
	"./NewCollectionsDashboard/PendingArticles/PendingArticlesTab.jsx": 1330,
	"./NewCollectionsDashboard/PendingArticles/Table": 1332,
	"./NewCollectionsDashboard/PendingArticles/Table.jsx": 1332,
	"./NewCollectionsDashboard/PublishedTab/CollectionLockSubsModal": 1329,
	"./NewCollectionsDashboard/PublishedTab/CollectionLockSubsModal.jsx": 1329,
	"./NewCollectionsDashboard/PublishedTab/CollectionRow": 1327,
	"./NewCollectionsDashboard/PublishedTab/CollectionRow.jsx": 1327,
	"./NewCollectionsDashboard/PublishedTab/PublishedTab": 1326,
	"./NewCollectionsDashboard/PublishedTab/PublishedTab.jsx": 1326,
	"./NewCollectionsDashboard/PublishedTab/Table": 1328,
	"./NewCollectionsDashboard/PublishedTab/Table.jsx": 1328,
	"./NewCollectionsDashboard/RejectedTab/CollectionRejectedModal": 1335,
	"./NewCollectionsDashboard/RejectedTab/CollectionRejectedModal.jsx": 1335,
	"./NewCollectionsDashboard/RejectedTab/RejectedCollectionCard": 1334,
	"./NewCollectionsDashboard/RejectedTab/RejectedCollectionCard.jsx": 1334,
	"./NewCollectionsDashboard/RejectedTab/RejectedTab": 1333,
	"./NewCollectionsDashboard/RejectedTab/RejectedTab.jsx": 1333,
	"./NewCollectionsDashboard/UnpublishedTab/CollectionCard": 1323,
	"./NewCollectionsDashboard/UnpublishedTab/CollectionCard.jsx": 1323,
	"./NewCollectionsDashboard/UnpublishedTab/CollectionDeleteModal": 1324,
	"./NewCollectionsDashboard/UnpublishedTab/CollectionDeleteModal.jsx": 1324,
	"./NewCollectionsDashboard/UnpublishedTab/DeferralModal": 1325,
	"./NewCollectionsDashboard/UnpublishedTab/DeferralModal.jsx": 1325,
	"./NewCollectionsDashboard/UnpublishedTab/UnpublishedTab": 1322,
	"./NewCollectionsDashboard/UnpublishedTab/UnpublishedTab.jsx": 1322,
	"./NewDashboard/Abstract": 1336,
	"./NewDashboard/Abstract.jsx": 1336,
	"./NewDashboard/Article": 1337,
	"./NewDashboard/Article.jsx": 1337,
	"./NewDashboard/ArticleExpanded": 1338,
	"./NewDashboard/ArticleExpanded.jsx": 1338,
	"./NewDashboard/CoauthoredArticle": 1339,
	"./NewDashboard/CoauthoredArticle.jsx": 1339,
	"./NewDashboard/DeletePosterAbstractModal": 347,
	"./NewDashboard/DeletePosterAbstractModal.jsx": 347,
	"./NewDashboard/EditorMessageModal": 348,
	"./NewDashboard/EditorMessageModal.jsx": 348,
	"./NewDashboard/InfoWidget": 1345,
	"./NewDashboard/InfoWidget.jsx": 1345,
	"./NewDashboard/Main": 1912,
	"./NewDashboard/Main.jsx": 1912,
	"./NewDashboard/Poster": 1346,
	"./NewDashboard/Poster.jsx": 1346,
	"./NewDashboard/PrimaryButton/Deferred": 1343,
	"./NewDashboard/PrimaryButton/Deferred.jsx": 1343,
	"./NewDashboard/PrimaryButton/InReview": 1342,
	"./NewDashboard/PrimaryButton/InReview.jsx": 1342,
	"./NewDashboard/PrimaryButton/PreviewPublishButton": 1913,
	"./NewDashboard/PrimaryButton/PreviewPublishButton.jsx": 1913,
	"./NewDashboard/PrimaryButton/RereviewsComplete": 1341,
	"./NewDashboard/PrimaryButton/RereviewsComplete.jsx": 1341,
	"./NewDashboard/PrimaryButton/ReviewsComplete": 1340,
	"./NewDashboard/PrimaryButton/ReviewsComplete.jsx": 1340,
	"./NewDashboard/PublishedArticle": 1344,
	"./NewDashboard/PublishedArticle.jsx": 1344,
	"./NewPersonIndex/DropDown": 563,
	"./NewPersonIndex/DropDown.jsx": 563,
	"./NewPersonIndex/DropDownInput": 564,
	"./NewPersonIndex/DropDownInput.jsx": 564,
	"./NewPersonIndex/FiltersModal": 1347,
	"./NewPersonIndex/FiltersModal.jsx": 1347,
	"./NewPersonIndex/InstitutionInput": 1348,
	"./NewPersonIndex/InstitutionInput.jsx": 1348,
	"./NewPersonIndex/LeftSidebar/Carat": 1349,
	"./NewPersonIndex/LeftSidebar/Carat.jsx": 1349,
	"./NewPersonIndex/LeftSidebar/Filters": 349,
	"./NewPersonIndex/LeftSidebar/Filters.jsx": 349,
	"./NewPersonIndex/LeftSidebar/List": 565,
	"./NewPersonIndex/LeftSidebar/List.jsx": 565,
	"./NewPersonIndex/LeftSidebar/Sidebar": 1350,
	"./NewPersonIndex/LeftSidebar/Sidebar.jsx": 1350,
	"./NewPersonIndex/Main": 1914,
	"./NewPersonIndex/Main.jsx": 1914,
	"./NewPersonIndex/MobilePersonRowCard": 1355,
	"./NewPersonIndex/MobilePersonRowCard.jsx": 1355,
	"./NewPersonIndex/PerPageViewSelector": 1357,
	"./NewPersonIndex/PerPageViewSelector.jsx": 1357,
	"./NewPersonIndex/PersonRowCard": 1354,
	"./NewPersonIndex/PersonRowCard.jsx": 1354,
	"./NewPersonIndex/ResultsHeader": 1358,
	"./NewPersonIndex/ResultsHeader.jsx": 1358,
	"./NewPersonIndex/RightSidebar": 1351,
	"./NewPersonIndex/RightSidebar.jsx": 1351,
	"./NewPersonIndex/SearchFields": 1352,
	"./NewPersonIndex/SearchFields.jsx": 1352,
	"./NewPersonIndex/SearchResults": 1353,
	"./NewPersonIndex/SearchResults.jsx": 1353,
	"./NewPersonIndex/SortButton": 180,
	"./NewPersonIndex/SortButton.jsx": 180,
	"./NewPersonIndex/SortButtons": 1356,
	"./NewPersonIndex/SortButtons.jsx": 1356,
	"./NewReviewsDashboard/DashboardKeywordTool": 165,
	"./NewReviewsDashboard/DashboardKeywordTool.jsx": 165,
	"./NewReviewsDashboard/InfoWidget": 248,
	"./NewReviewsDashboard/InfoWidget.jsx": 248,
	"./NewReviewsDashboard/KeywordAutoSuggester": 452,
	"./NewReviewsDashboard/KeywordAutoSuggester.jsx": 452,
	"./NewReviewsDashboard/Main": 1508,
	"./NewReviewsDashboard/Main.jsx": 1508,
	"./NewReviewsDashboard/Reviewership": 453,
	"./NewReviewsDashboard/Reviewership.jsx": 453,
	"./NewsroomCarousel": 1915,
	"./NewsroomCarousel.js": 1915,
	"./NewsroomCarousel/Main": 1916,
	"./NewsroomCarousel/Main.jsx": 1916,
	"./NewsroomCarousel/Post": 1359,
	"./NewsroomCarousel/Post.jsx": 1359,
	"./NewsroomPosts": 1917,
	"./NewsroomPosts.js": 1917,
	"./NewsroomPosts/Inside": 1360,
	"./NewsroomPosts/Inside.jsx": 1360,
	"./NewsroomPosts/InsideListItem": 1361,
	"./NewsroomPosts/InsideListItem.jsx": 1361,
	"./NewsroomPosts/NewsroomMain": 1918,
	"./NewsroomPosts/NewsroomMain.jsx": 1918,
	"./NotificationsCenter/ApprovalEditorOneMatchModal": 140,
	"./NotificationsCenter/ApprovalEditorOneMatchModal.jsx": 140,
	"./NotificationsCenter/ApprovalEditorResubmittedModal": 141,
	"./NotificationsCenter/ApprovalEditorResubmittedModal.jsx": 141,
	"./NotificationsCenter/AuthorStaleReviewsCompleteModal": 142,
	"./NotificationsCenter/AuthorStaleReviewsCompleteModal.jsx": 142,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal": 143,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal.jsx": 143,
	"./NotificationsCenter/CollectionApplicationApprovalModal": 144,
	"./NotificationsCenter/CollectionApplicationApprovalModal.jsx": 144,
	"./NotificationsCenter/DraftReadyForSubmissionModal": 145,
	"./NotificationsCenter/DraftReadyForSubmissionModal.jsx": 145,
	"./NotificationsCenter/GuestEditorModal": 146,
	"./NotificationsCenter/GuestEditorModal.jsx": 146,
	"./NotificationsCenter/Main": 147,
	"./NotificationsCenter/Main.jsx": 147,
	"./NotificationsCenter/ReferralProgramModal": 148,
	"./NotificationsCenter/ReferralProgramModal.jsx": 148,
	"./NotificationsCenter/ReviewerModal": 149,
	"./NotificationsCenter/ReviewerModal.jsx": 149,
	"./NpiModal/Main": 1919,
	"./NpiModal/Main.jsx": 1919,
	"./NpiModal/NpiModal": 1362,
	"./NpiModal/NpiModal.jsx": 1362,
	"./OnDemand/Article": 206,
	"./OnDemand/Article.jsx": 206,
	"./OnDemand/ArticleTabs": 540,
	"./OnDemand/ArticleTabs.jsx": 540,
	"./OnDemand/Intro": 538,
	"./OnDemand/Intro.jsx": 538,
	"./OnDemand/Main": 242,
	"./OnDemand/Main.jsx": 242,
	"./OnDemand/OnDemandModal": 537,
	"./OnDemand/OnDemandModal.jsx": 537,
	"./OnDemand/Selection": 539,
	"./OnDemand/Selection.jsx": 539,
	"./PastCompetitions/Card": 454,
	"./PastCompetitions/Card.jsx": 454,
	"./PastCompetitions/Index": 1509,
	"./PastCompetitions/Index.jsx": 1509,
	"./PastCompetitions/Tab": 456,
	"./PastCompetitions/Tab.jsx": 456,
	"./PastCompetitions/TabComponent": 455,
	"./PastCompetitions/TabComponent.jsx": 455,
	"./PaymentConfirmation": 1920,
	"./PaymentConfirmation.js": 1920,
	"./PaymentConfirmation/Main": 1921,
	"./PaymentConfirmation/Main.jsx": 1921,
	"./PeerReviewReport/Main": 1922,
	"./PeerReviewReport/Main.jsx": 1922,
	"./PeerReviewReport/PeerReviewQuestion": 566,
	"./PeerReviewReport/PeerReviewQuestion.jsx": 566,
	"./PersonIndex": 1923,
	"./PersonIndex.js": 1923,
	"./PersonIndex/Filters": 1363,
	"./PersonIndex/Filters.jsx": 1363,
	"./PersonIndex/Main": 1924,
	"./PersonIndex/Main.jsx": 1924,
	"./PersonIndex/Search": 1367,
	"./PersonIndex/Search.jsx": 1367,
	"./PersonIndex/Sort": 1364,
	"./PersonIndex/Sort.jsx": 1364,
	"./PersonIndex/Specialties": 1365,
	"./PersonIndex/Specialties.jsx": 1365,
	"./PersonIndex/SpecialtiesModal": 1366,
	"./PersonIndex/SpecialtiesModal.jsx": 1366,
	"./PicturePrognosis/CompletedAnswer": 289,
	"./PicturePrognosis/CompletedAnswer.jsx": 289,
	"./PicturePrognosis/HistoryTable": 1925,
	"./PicturePrognosis/HistoryTable.jsx": 1925,
	"./PicturePrognosis/New": 286,
	"./PicturePrognosis/New.jsx": 286,
	"./PicturePrognosis/QuestionInput": 287,
	"./PicturePrognosis/QuestionInput.jsx": 287,
	"./PicturePrognosis/QueueModal": 288,
	"./PicturePrognosis/QueueModal.jsx": 288,
	"./PicturePrognosisBacklog/Main": 1926,
	"./PicturePrognosisBacklog/Main.jsx": 1926,
	"./PicturePrognosisBacklog/PictureQuizCard": 350,
	"./PicturePrognosisBacklog/PictureQuizCard.jsx": 350,
	"./PicturePrognosisBacklog/Show": 1927,
	"./PicturePrognosisBacklog/Show.jsx": 1927,
	"./PicturePrognosisHome/AnswerBarRow": 104,
	"./PicturePrognosisHome/AnswerBarRow.jsx": 104,
	"./PicturePrognosisHome/AnswerOption": 226,
	"./PicturePrognosisHome/AnswerOption.jsx": 226,
	"./PicturePrognosisHome/AnswerOutcome": 227,
	"./PicturePrognosisHome/AnswerOutcome.jsx": 227,
	"./PicturePrognosisHome/Clarification": 228,
	"./PicturePrognosisHome/Clarification.jsx": 228,
	"./PicturePrognosisHome/Landing": 935,
	"./PicturePrognosisHome/Landing.jsx": 935,
	"./PicturePrognosisHome/Widget": 274,
	"./PicturePrognosisHome/Widget.jsx": 274,
	"./Popper": 572,
	"./Popper.js": 572,
	"./Popper/Link": 100,
	"./Popper/Link.jsx": 100,
	"./Popper/Main": 241,
	"./Popper/Main.jsx": 241,
	"./PosterUploader": 1928,
	"./PosterUploader.js": 1928,
	"./PosterUploader/EditFile": 1368,
	"./PosterUploader/EditFile.jsx": 1368,
	"./PosterUploader/Main": 1929,
	"./PosterUploader/Main.jsx": 1929,
	"./PosterUploader/NewFile": 1369,
	"./PosterUploader/NewFile.jsx": 1369,
	"./Publishing": 1930,
	"./Publishing.js": 1930,
	"./Publishing/ChannelFilter": 1931,
	"./Publishing/ChannelFilter.jsx": 1931,
	"./Publishing/ChannelTile": 1370,
	"./Publishing/ChannelTile.jsx": 1370,
	"./Publishing/Channels/ChannelListings": 1371,
	"./Publishing/Channels/ChannelListings.jsx": 1371,
	"./Publishing/Channels/ChannelMapOrList": 1372,
	"./Publishing/Channels/ChannelMapOrList.jsx": 1372,
	"./Publishing/Channels/ChannelSelector": 1932,
	"./Publishing/Channels/ChannelSelector.jsx": 1932,
	"./Publishing/Channels/SubChannelModal": 1374,
	"./Publishing/Channels/SubChannelModal.jsx": 1374,
	"./Publishing/Channels/ToggleViewButton": 1373,
	"./Publishing/Channels/ToggleViewButton.jsx": 1373,
	"./Publishing/CoiResponsibility": 1933,
	"./Publishing/CoiResponsibility.jsx": 1933,
	"./Publishing/CollectionSelector": 1934,
	"./Publishing/CollectionSelector.jsx": 1934,
	"./Publishing/CollectionTile": 1375,
	"./Publishing/CollectionTile.jsx": 1375,
	"./Publishing/CompetitionSelector": 1935,
	"./Publishing/CompetitionSelector.jsx": 1935,
	"./Publishing/CompetitionTile": 1376,
	"./Publishing/CompetitionTile.jsx": 1376,
	"./Publishing/UserTool/Affiliation": 967,
	"./Publishing/UserTool/Affiliation.jsx": 967,
	"./Publishing/UserTool/ApiClient": 37,
	"./Publishing/UserTool/ApiClient.js": 37,
	"./Publishing/UserTool/AuthorDetailsModal": 971,
	"./Publishing/UserTool/AuthorDetailsModal.jsx": 971,
	"./Publishing/UserTool/AuthorForm": 965,
	"./Publishing/UserTool/AuthorForm.jsx": 965,
	"./Publishing/UserTool/ChangeEmailModal": 970,
	"./Publishing/UserTool/ChangeEmailModal.jsx": 970,
	"./Publishing/UserTool/CorrespondentModal": 973,
	"./Publishing/UserTool/CorrespondentModal.jsx": 973,
	"./Publishing/UserTool/DeleteAuthorModal": 972,
	"./Publishing/UserTool/DeleteAuthorModal.jsx": 972,
	"./Publishing/UserTool/Department": 968,
	"./Publishing/UserTool/Department.jsx": 968,
	"./Publishing/UserTool/EditModal": 963,
	"./Publishing/UserTool/EditModal.jsx": 963,
	"./Publishing/UserTool/Institution": 969,
	"./Publishing/UserTool/Institution.jsx": 969,
	"./Publishing/UserTool/Main": 310,
	"./Publishing/UserTool/Main.jsx": 310,
	"./Publishing/UserTool/NewModal": 311,
	"./Publishing/UserTool/NewModal.jsx": 311,
	"./Publishing/UserTool/Row": 964,
	"./Publishing/UserTool/Row.jsx": 964,
	"./ReferenceTool": 1936,
	"./ReferenceTool.js": 1936,
	"./ReferenceTool/DisplayReference": 1377,
	"./ReferenceTool/DisplayReference.jsx": 1377,
	"./ReferenceTool/EditReference": 1378,
	"./ReferenceTool/EditReference.jsx": 1378,
	"./ReferenceTool/FieldSet": 351,
	"./ReferenceTool/FieldSet.jsx": 351,
	"./ReferenceTool/Importer": 1379,
	"./ReferenceTool/Importer.jsx": 1379,
	"./ReferenceTool/Main": 1937,
	"./ReferenceTool/Main.jsx": 1937,
	"./ReferenceTool/NewReference": 1382,
	"./ReferenceTool/NewReference.jsx": 1382,
	"./ReferenceTool/NewReferenceFields": 1383,
	"./ReferenceTool/NewReferenceFields.jsx": 1383,
	"./ReferenceTool/ReferenceField": 352,
	"./ReferenceTool/ReferenceField.jsx": 352,
	"./ReferenceTool/ReferenceMetadataModal": 567,
	"./ReferenceTool/ReferenceMetadataModal.jsx": 567,
	"./ReferenceTool/ReferenceRow": 1381,
	"./ReferenceTool/ReferenceRow.jsx": 1381,
	"./ReferenceTool/ReferencesList": 1380,
	"./ReferenceTool/ReferencesList.jsx": 1380,
	"./Referrals/Index": 1938,
	"./Referrals/Index.jsx": 1938,
	"./ReviewerQuestionnaire/Coi": 1384,
	"./ReviewerQuestionnaire/Coi.jsx": 1384,
	"./ReviewerQuestionnaire/ConclusionCard": 354,
	"./ReviewerQuestionnaire/ConclusionCard.jsx": 354,
	"./ReviewerQuestionnaire/CredibleConclusions": 1385,
	"./ReviewerQuestionnaire/CredibleConclusions.jsx": 1385,
	"./ReviewerQuestionnaire/Label": 177,
	"./ReviewerQuestionnaire/Label.jsx": 177,
	"./ReviewerQuestionnaire/Main": 1939,
	"./ReviewerQuestionnaire/Main.jsx": 1939,
	"./ReviewerQuestionnaire/QuestionAnswerItem": 1386,
	"./ReviewerQuestionnaire/QuestionAnswerItem.jsx": 1386,
	"./ReviewerTool": 1940,
	"./ReviewerTool.js": 1940,
	"./ReviewerTool/AnnotationComment": 568,
	"./ReviewerTool/AnnotationComment.jsx": 568,
	"./ReviewerTool/Main": 1941,
	"./ReviewerTool/Main.jsx": 1941,
	"./ReviewerTool/PointToPointModal": 1389,
	"./ReviewerTool/PointToPointModal.jsx": 1389,
	"./ReviewerTool/QuestionnaireQuestionComment": 1390,
	"./ReviewerTool/QuestionnaireQuestionComment.jsx": 1390,
	"./ReviewerTool/Row": 1388,
	"./ReviewerTool/Row.jsx": 1388,
	"./ReviewerTool/VersionsTable": 1387,
	"./ReviewerTool/VersionsTable.jsx": 1387,
	"./Scoring/Main": 1942,
	"./Scoring/Main.jsx": 1942,
	"./Scoring/ScoringModal": 169,
	"./Scoring/ScoringModal.jsx": 169,
	"./Scoring/Slider": 1053,
	"./Scoring/Slider.jsx": 1053,
	"./Scoring/ThankYouModal": 1052,
	"./Scoring/ThankYouModal.jsx": 1052,
	"./SearchTool": 1943,
	"./SearchTool.js": 1943,
	"./SearchTool/PMCFilters": 533,
	"./SearchTool/PMCFilters.jsx": 533,
	"./SearchTool/PMCOrder": 535,
	"./SearchTool/PMCOrder.jsx": 535,
	"./SearchTool/PMCPagination": 534,
	"./SearchTool/PMCPagination.jsx": 534,
	"./SearchTool/fluxxor/actions": 1944,
	"./SearchTool/fluxxor/actions.js": 1944,
	"./SearchTool/fluxxor/constants": 1391,
	"./SearchTool/fluxxor/constants.js": 1391,
	"./SearchTool/fluxxor/stores/Search": 1945,
	"./SearchTool/fluxxor/stores/Search.js": 1945,
	"./Shared": 1510,
	"./Shared.js": 1510,
	"./Shared/Ad": 28,
	"./Shared/Ad.jsx": 28,
	"./Shared/AuthorsAndReviewersBanModal": 231,
	"./Shared/AuthorsAndReviewersBanModal.jsx": 231,
	"./Shared/Buttons/CollectionButton": 346,
	"./Shared/Buttons/CollectionButton.jsx": 346,
	"./Shared/Categories": 65,
	"./Shared/Categories.jsx": 65,
	"./Shared/Collapse": 528,
	"./Shared/Collapse.jsx": 528,
	"./Shared/ContentCards/AbstractCard": 373,
	"./Shared/ContentCards/AbstractCard.jsx": 373,
	"./Shared/ContentCards/AbstractPosterCard": 527,
	"./Shared/ContentCards/AbstractPosterCard.jsx": 527,
	"./Shared/ContentCards/ArticleCard": 92,
	"./Shared/ContentCards/ArticleCard.jsx": 92,
	"./Shared/ContentCards/ArticleContentCard": 525,
	"./Shared/ContentCards/ArticleContentCard.jsx": 525,
	"./Shared/ContentCards/BigArticleCard": 44,
	"./Shared/ContentCards/BigArticleCard.jsx": 44,
	"./Shared/ContentCards/CorrectionRetractionCard": 245,
	"./Shared/ContentCards/CorrectionRetractionCard.jsx": 245,
	"./Shared/ContentCards/DiscussionCard": 230,
	"./Shared/ContentCards/DiscussionCard.jsx": 230,
	"./Shared/ContentCards/InternalContentCard": 105,
	"./Shared/ContentCards/InternalContentCard.jsx": 105,
	"./Shared/ContentCards/MeetingCard": 530,
	"./Shared/ContentCards/MeetingCard.jsx": 530,
	"./Shared/ContentCards/NewArticleCard": 201,
	"./Shared/ContentCards/NewArticleCard.jsx": 201,
	"./Shared/ContentCards/PersonCard": 200,
	"./Shared/ContentCards/PersonCard.jsx": 200,
	"./Shared/ContentCards/PmcCard": 371,
	"./Shared/ContentCards/PmcCard.jsx": 371,
	"./Shared/ContentCards/PosterCard": 372,
	"./Shared/ContentCards/PosterCard.jsx": 372,
	"./Shared/ContentCards/SmallArticleCard": 64,
	"./Shared/ContentCards/SmallArticleCard.jsx": 64,
	"./Shared/ContentCards/UserCard": 1511,
	"./Shared/ContentCards/UserCard.jsx": 1511,
	"./Shared/DashboardBannerMessage": 1512,
	"./Shared/DashboardBannerMessage.jsx": 1512,
	"./Shared/DropDownArticleStates/Abandoned": 521,
	"./Shared/DropDownArticleStates/Abandoned.jsx": 521,
	"./Shared/DropDownArticleStates/All": 522,
	"./Shared/DropDownArticleStates/All.jsx": 522,
	"./Shared/DropDownArticleStates/Approved": 517,
	"./Shared/DropDownArticleStates/Approved.jsx": 517,
	"./Shared/DropDownArticleStates/Blocked": 520,
	"./Shared/DropDownArticleStates/Blocked.jsx": 520,
	"./Shared/DropDownArticleStates/ChannelEditorApproval": 513,
	"./Shared/DropDownArticleStates/ChannelEditorApproval.jsx": 513,
	"./Shared/DropDownArticleStates/ChannelEditorApprovalDeferred": 514,
	"./Shared/DropDownArticleStates/ChannelEditorApprovalDeferred.jsx": 514,
	"./Shared/DropDownArticleStates/CureusEditorApproval": 515,
	"./Shared/DropDownArticleStates/CureusEditorApproval.jsx": 515,
	"./Shared/DropDownArticleStates/CureusEditorApprovalDeferred": 516,
	"./Shared/DropDownArticleStates/CureusEditorApprovalDeferred.jsx": 516,
	"./Shared/DropDownArticleStates/DeskRejected": 519,
	"./Shared/DropDownArticleStates/DeskRejected.jsx": 519,
	"./Shared/DropDownArticleStates/Draft": 506,
	"./Shared/DropDownArticleStates/Draft.jsx": 506,
	"./Shared/DropDownArticleStates/EditorCheck": 509,
	"./Shared/DropDownArticleStates/EditorCheck.jsx": 509,
	"./Shared/DropDownArticleStates/EditorCheckDeferred": 510,
	"./Shared/DropDownArticleStates/EditorCheckDeferred.jsx": 510,
	"./Shared/DropDownArticleStates/EditorPreview": 507,
	"./Shared/DropDownArticleStates/EditorPreview.jsx": 507,
	"./Shared/DropDownArticleStates/EditorPreviewDeferred": 508,
	"./Shared/DropDownArticleStates/EditorPreviewDeferred.jsx": 508,
	"./Shared/DropDownArticleStates/InReview": 511,
	"./Shared/DropDownArticleStates/InReview.jsx": 511,
	"./Shared/DropDownArticleStates/Published": 518,
	"./Shared/DropDownArticleStates/Published.jsx": 518,
	"./Shared/DropDownArticleStates/ReviewsComplete": 512,
	"./Shared/DropDownArticleStates/ReviewsComplete.jsx": 512,
	"./Shared/Dropdown": 238,
	"./Shared/Dropdown.jsx": 238,
	"./Shared/DynamicJqueryTable": 39,
	"./Shared/DynamicJqueryTable.jsx": 39,
	"./Shared/FilterTab/Filter": 71,
	"./Shared/FilterTab/Filter.jsx": 71,
	"./Shared/FilterTab/FilterWrapper": 1513,
	"./Shared/FilterTab/FilterWrapper.jsx": 1513,
	"./Shared/FilterTab/Pill": 531,
	"./Shared/FilterTab/Pill.jsx": 531,
	"./Shared/LikeButton": 99,
	"./Shared/LikeButton.jsx": 99,
	"./Shared/List/List": 375,
	"./Shared/List/List.jsx": 375,
	"./Shared/Pagination/EllipsePage": 246,
	"./Shared/Pagination/EllipsePage.jsx": 246,
	"./Shared/Pagination/EllipsePages": 240,
	"./Shared/Pagination/EllipsePages.jsx": 240,
	"./Shared/Pagination/Page": 166,
	"./Shared/Pagination/Page.jsx": 166,
	"./Shared/Pagination/Pages": 20,
	"./Shared/Pagination/Pages.jsx": 20,
	"./Shared/PublishingStepButtons": 237,
	"./Shared/PublishingStepButtons.jsx": 237,
	"./Shared/RadioContainer": 62,
	"./Shared/RadioContainer.jsx": 62,
	"./Shared/SearchBar/SearchBar": 54,
	"./Shared/SearchBar/SearchBar.jsx": 54,
	"./Shared/SiqBadgeImage": 47,
	"./Shared/SiqBadgeImage.jsx": 47,
	"./Shared/SiqHover": 374,
	"./Shared/SiqHover.jsx": 374,
	"./Shared/SiqHoverWrapper": 523,
	"./Shared/SiqHoverWrapper.jsx": 523,
	"./Shared/Tabs": 150,
	"./Shared/Tabs.jsx": 150,
	"./Shared/TopAuthors": 239,
	"./Shared/TopAuthors.jsx": 239,
	"./Shared/TopContent": 529,
	"./Shared/TopContent.jsx": 529,
	"./Shared/Utility/Checkbox": 327,
	"./Shared/Utility/Checkbox.jsx": 327,
	"./Shared/Utility/ExportCSVButton": 88,
	"./Shared/Utility/ExportCSVButton.jsx": 88,
	"./Shared/Utility/LeafletMap/BottomBackButton": 359,
	"./Shared/Utility/LeafletMap/BottomBackButton.jsx": 359,
	"./Shared/Utility/LeafletMap/Channels/AddMarkers": 244,
	"./Shared/Utility/LeafletMap/Channels/AddMarkers.js": 244,
	"./Shared/Utility/LeafletMap/Channels/MarkersAndIcons": 56,
	"./Shared/Utility/LeafletMap/Channels/MarkersAndIcons.js": 56,
	"./Shared/Utility/LeafletMap/CreateMarker": 134,
	"./Shared/Utility/LeafletMap/CreateMarker.js": 134,
	"./Shared/Utility/LeafletMap/FullScreenButton": 360,
	"./Shared/Utility/LeafletMap/FullScreenButton.jsx": 360,
	"./Shared/Utility/LeafletMap/LeafletLoader": 243,
	"./Shared/Utility/LeafletMap/LeafletLoader.js": 243,
	"./Shared/Utility/LeafletMap/MapView": 232,
	"./Shared/Utility/LeafletMap/MapView.jsx": 232,
	"./Shared/Utility/SearchBar": 526,
	"./Shared/Utility/SearchBar.jsx": 526,
	"./Shared/Utility/TableDataFetcher": 358,
	"./Shared/Utility/TableDataFetcher.js": 358,
	"./SiqFooter": 1946,
	"./SiqFooter.js": 1946,
	"./SiqFooter/Main": 1947,
	"./SiqFooter/Main.jsx": 1947,
	"./SiqFooter/Siq": 1392,
	"./SiqFooter/Siq.jsx": 1392,
	"./SocialBoostCarousel/Main": 1514,
	"./SocialBoostCarousel/Main.jsx": 1514,
	"./SocialBoostCarousel/SocialBoostQuote": 457,
	"./SocialBoostCarousel/SocialBoostQuote.jsx": 457,
	"./SocialChannels": 1948,
	"./SocialChannels.js": 1948,
	"./SocialChannels/Button": 541,
	"./SocialChannels/Button.jsx": 541,
	"./SocialChannels/Main": 542,
	"./SocialChannels/Main.jsx": 542,
	"./Sortable": 21,
	"./Sortable.jsx": 21,
	"./Specialties/Main": 1949,
	"./Specialties/Main.jsx": 1949,
	"./Specialties/SpecialtyCard": 1393,
	"./Specialties/SpecialtyCard.jsx": 1393,
	"./StatsWidget": 1950,
	"./StatsWidget.js": 1950,
	"./StatsWidget/ActivityHistory": 1394,
	"./StatsWidget/ActivityHistory.jsx": 1394,
	"./StatsWidget/ApprovalEditorsByArticleCategory": 1395,
	"./StatsWidget/ApprovalEditorsByArticleCategory.jsx": 1395,
	"./StatsWidget/ArticlesModal": 1396,
	"./StatsWidget/ArticlesModal.jsx": 1396,
	"./StatsWidget/BarChart": 1397,
	"./StatsWidget/BarChart.jsx": 1397,
	"./StatsWidget/BarChartRow": 1168,
	"./StatsWidget/BarChartRow.jsx": 1168,
	"./StatsWidget/BarGraphWidget": 1167,
	"./StatsWidget/BarGraphWidget.jsx": 1167,
	"./StatsWidget/Chart": 1951,
	"./StatsWidget/Chart.jsx": 1951,
	"./StatsWidget/ClaimedArticles": 1403,
	"./StatsWidget/ClaimedArticles.jsx": 1403,
	"./StatsWidget/DateSelector": 15,
	"./StatsWidget/DateSelector.jsx": 15,
	"./StatsWidget/DeskSubmissions": 1405,
	"./StatsWidget/DeskSubmissions.jsx": 1405,
	"./StatsWidget/EditorTotals": 1406,
	"./StatsWidget/EditorTotals.jsx": 1406,
	"./StatsWidget/EditorialWidgetBody": 328,
	"./StatsWidget/EditorialWidgetBody.jsx": 328,
	"./StatsWidget/InvoicesWidget": 1164,
	"./StatsWidget/InvoicesWidget.jsx": 1164,
	"./StatsWidget/IterativeStatsWidget": 1166,
	"./StatsWidget/IterativeStatsWidget.jsx": 1166,
	"./StatsWidget/LineChart": 1399,
	"./StatsWidget/LineChart.jsx": 1399,
	"./StatsWidget/LineItemWidget": 1496,
	"./StatsWidget/LineItemWidget.jsx": 1496,
	"./StatsWidget/MatchedArticles": 1404,
	"./StatsWidget/MatchedArticles.jsx": 1404,
	"./StatsWidget/PieChart": 1400,
	"./StatsWidget/PieChart.jsx": 1400,
	"./StatsWidget/ProgressCard": 355,
	"./StatsWidget/ProgressCard.jsx": 355,
	"./StatsWidget/ProgressStats": 1402,
	"./StatsWidget/ProgressStats.jsx": 1402,
	"./StatsWidget/PublishedContentWidget": 1165,
	"./StatsWidget/PublishedContentWidget.jsx": 1165,
	"./StatsWidget/ScatterChart": 1401,
	"./StatsWidget/ScatterChart.jsx": 1401,
	"./StatsWidget/StackedBarChart": 1398,
	"./StatsWidget/StackedBarChart.jsx": 1398,
	"./StatsWidget/Table": 1952,
	"./StatsWidget/Table.jsx": 1952,
	"./StatsWidget/TableSelector": 1953,
	"./StatsWidget/TableSelector.jsx": 1953,
	"./StatsWidget/Widget": 557,
	"./StatsWidget/Widget.jsx": 557,
	"./StripeV2": 1954,
	"./StripeV2.js": 1954,
	"./StripeV2/Card": 552,
	"./StripeV2/Card.jsx": 552,
	"./StripeV2/ExpeditedPmcModal": 1086,
	"./StripeV2/ExpeditedPmcModal.jsx": 1086,
	"./StripeV2/Main": 171,
	"./StripeV2/Main.jsx": 171,
	"./StripeV2/Payment": 1087,
	"./StripeV2/Payment.jsx": 1087,
	"./StripeV2/PreferredEditingModal": 1085,
	"./StripeV2/PreferredEditingModal.jsx": 1085,
	"./StripeV2/PreferredLandingPage": 1088,
	"./StripeV2/PreferredLandingPage.jsx": 1088,
	"./StripeV2/SocialBoost": 1084,
	"./StripeV2/SocialBoost.jsx": 1084,
	"./StripeV2/SocialBoostLandingPage": 1089,
	"./StripeV2/SocialBoostLandingPage.jsx": 1089,
	"./SubmitRereview": 1955,
	"./SubmitRereview.js": 1955,
	"./SubmitReview": 1956,
	"./SubmitReview.js": 1956,
	"./SubmitReview/Main": 1957,
	"./SubmitReview/Main.jsx": 1957,
	"./SubmitReview/NewSubmitModal": 1407,
	"./SubmitReview/NewSubmitModal.jsx": 1407,
	"./SubmitReview/StepOne": 1408,
	"./SubmitReview/StepOne.jsx": 1408,
	"./SubmitReview/StepThree": 1410,
	"./SubmitReview/StepThree.jsx": 1410,
	"./SubmitReview/StepTwo": 1409,
	"./SubmitReview/StepTwo.jsx": 1409,
	"./TextAreaCounter": 1958,
	"./TextAreaCounter.jsx": 1958,
	"./TopicTool": 1959,
	"./TopicTool.jsx": 1959,
	"./Transloadit": 324,
	"./Transloadit.jsx": 324,
	"./TransloaditFileDrop": 170,
	"./TransloaditFileDrop.jsx": 170,
	"./TrendingTopics/AddModal": 281,
	"./TrendingTopics/AddModal.jsx": 281,
	"./TrendingTopics/Index": 277,
	"./TrendingTopics/Index.jsx": 277,
	"./TrendingTopics/Selected": 279,
	"./TrendingTopics/Selected.jsx": 279,
	"./TrendingTopics/Table": 278,
	"./TrendingTopics/Table.jsx": 278,
	"./TrendingTopics/Topic": 280,
	"./TrendingTopics/Topic.jsx": 280,
	"./UserMergeTool": 1960,
	"./UserMergeTool.js": 1960,
	"./UserMergeTool/Main": 1961,
	"./UserMergeTool/Main.jsx": 1961,
	"./UserMergeTool/Picker": 570,
	"./UserMergeTool/Picker.jsx": 570,
	"./UserMergeTool/UserDetails": 569,
	"./UserMergeTool/UserDetails.jsx": 569,
	"./UserPicker": 1962,
	"./UserPicker.js": 1962,
	"./UserPicker/DepartmentAutoSuggester": 151,
	"./UserPicker/DepartmentAutoSuggester.jsx": 151,
	"./UserPicker/Form": 124,
	"./UserPicker/Form.jsx": 124,
	"./UserPicker/InstitutionAutoSuggester": 152,
	"./UserPicker/InstitutionAutoSuggester.jsx": 152,
	"./UserPicker/Name": 966,
	"./UserPicker/Name.jsx": 966,
	"./UserProfile": 1515,
	"./UserProfile.js": 1515,
	"./UserProfile/Biography": 1516,
	"./UserProfile/Biography.jsx": 1516,
	"./UserProfile/ContentCard": 275,
	"./UserProfile/ContentCard.jsx": 275,
	"./UserProfile/Main": 1517,
	"./UserProfile/Main.jsx": 1517,
	"./UserProfile/SiqHover": 1518,
	"./UserProfile/SiqHover.jsx": 1518,
	"./UserProfileModals": 1519,
	"./UserProfileModals.js": 1519,
	"./UserProfileModals/AffiliationsMain": 458,
	"./UserProfileModals/AffiliationsMain.jsx": 458,
	"./UserProfileModals/AffiliationsRow": 459,
	"./UserProfileModals/AffiliationsRow.jsx": 459,
	"./UserProfileModals/EditAboutMe": 460,
	"./UserProfileModals/EditAboutMe.jsx": 460,
	"./UserProfileModals/EditInstitutionalEmail": 461,
	"./UserProfileModals/EditInstitutionalEmail.jsx": 461,
	"./UserProfileModals/EditProfile": 462,
	"./UserProfileModals/EditProfile.jsx": 462,
	"./UserProfileModals/Main": 1520,
	"./UserProfileModals/Main.jsx": 1520,
	"./UserProfileModals/Npi": 464,
	"./UserProfileModals/Npi.jsx": 464,
	"./UserProfileModals/NpiEdit": 465,
	"./UserProfileModals/NpiEdit.jsx": 465,
	"./UserProfileModals/NpiOther": 466,
	"./UserProfileModals/NpiOther.jsx": 466,
	"./UserProfileModals/NpiRegistered": 468,
	"./UserProfileModals/NpiRegistered.jsx": 468,
	"./UserProfileModals/NpiRows": 205,
	"./UserProfileModals/NpiRows.jsx": 205,
	"./UserProfileModals/NpiUs": 467,
	"./UserProfileModals/NpiUs.jsx": 467,
	"./UserProfileModals/PeerReviewPanel": 469,
	"./UserProfileModals/PeerReviewPanel.jsx": 469,
	"./UserProfileModals/PhoneNumber": 463,
	"./UserProfileModals/PhoneNumber.jsx": 463,
	"./UserProfileModals/PublicProfile": 470,
	"./UserProfileModals/PublicProfile.jsx": 470,
	"./UsersPage/Activities": 1521,
	"./UsersPage/Activities.jsx": 1521,
	"./UsersPage/Coauthors": 1522,
	"./UsersPage/Coauthors.jsx": 1522,
	"./WallOfShame/List": 1963,
	"./WallOfShame/List.jsx": 1963,
	"./WallOfShame/NewOrganizationModal": 1412,
	"./WallOfShame/NewOrganizationModal.jsx": 1412,
	"./WallOfShame/NewUserModal": 1413,
	"./WallOfShame/NewUserModal.jsx": 1413,
	"./WallOfShame/Organizations": 1964,
	"./WallOfShame/Organizations.jsx": 1964,
	"./WallOfShame/Users": 1965,
	"./WallOfShame/Users.jsx": 1965,
	"./WallOfShame/WallOfShameRow": 1411,
	"./WallOfShame/WallOfShameRow.jsx": 1411,
	"./useClickOutside": 49,
	"./useClickOutside.jsx": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2164;